(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8497],{

/***/ 75178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12426);
/* harmony import */ var _CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _selectDropDown_SelectDropDown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31201);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var DeliveryAddress = function DeliveryAddress(_ref) {
  var formName = _ref.formName,
      variant = _ref.variant,
      validations = _ref.validations,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      readOnlyValues = _ref.readOnlyValues,
      addressTypesOptions = _ref.addressTypesOptions,
      stateTypesOptions = _ref.stateTypesOptions,
      onChangeHandler = _ref.onChangeHandler,
      onBlurHandler = _ref.onBlurHandler,
      containerClassName = _ref.containerClassName,
      rowClassName = _ref.rowClassName,
      isGuestUser = _ref.isGuestUser;

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  var handleDropdown = function handleDropdown(event) {
    var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var formName = arguments.length > 2 ? arguments[2] : undefined;
    onChangeHandler(event, val, formName);
    onBlurHandler(event, val, formName);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
    className: "".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[variant], " ").concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["main-container"]), "  ").concat(containerClassName),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Row, {
      className: "".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["main-row"]), " ").concat(rowClassName),
      children: [formName !== 'companyInformation' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          sm: "12",
          md: "12",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormda101-".concat(variant, "-").concat(formName),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"]),
            id: "validationFormda101-label-".concat(variant, "-").concat(formName),
            children: "Address type"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "addressName",
            value: fieldValues['addressName'],
            placeholder: "Home address / Work address",
            onChange: handleChange,
            onBlur: handleBlur,
            readOnly: readOnlyValues['addressName'],
            isInvalid: fieldErrors['addressName'],
            className: fieldErrors['addressName'] ? (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage['addressName']
          }), !fieldErrors['addressName'] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["hint-text"]),
            children: "What you normally call this address (e.g. Home, Work)"
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Row, {
        className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-row"]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
          className: "d-block d-sm-none ".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
          id: "validationFormda103-mob-label-".concat(variant, "-").concat(formName),
          children: ["Unit no. & Complex name", !validations['unitNo'] && !validations['complexName'] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            children: ' (Optional)'
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          xs: "4",
          sm: "4",
          lg: "5",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormda103-".concat(variant, "-").concat(formName),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: "d-none d-sm-block ".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
            id: "validationFormda103-label-".concat(variant, "-").concat(formName),
            children: ["Unit no / Floor no", !validations['unitNo'] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              children: ' (Optional)'
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "unitNo",
            value: fieldValues['unitNo'],
            placeholder: "#",
            onChange: handleChange,
            onBlur: handleBlur,
            readOnly: readOnlyValues['unitNo'],
            isInvalid: fieldErrors['unitNo'],
            className: fieldErrors['unitNo'] ? (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage['unitNo']
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          xs: "8",
          sm: "8",
          lg: "7",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormda104-".concat(variant, "-").concat(formName),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: "d-none d-sm-block ".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
            id: "validationFormda104-label-".concat(variant, "-").concat(formName),
            children: ["Complex name / Business name", !validations['complexName'] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              children: ' (Optional)'
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "complexName",
            value: fieldValues['complexName'],
            placeholder: "Add complex name or business name",
            onChange: handleChange,
            onBlur: handleBlur,
            readOnly: readOnlyValues['complexName'],
            isInvalid: fieldErrors['complexName'],
            className: fieldErrors['complexName'] ? (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage['complexName']
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Row, {
        className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-row"]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
          className: "d-block d-sm-none ".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
          id: "validationFormda105-mob-label-".concat(variant, "-").concat(formName),
          children: ["Street no.", !validations['streetNo'] && validations['streetName'] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            children: '(Optional) '
          }), "& Street name"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          xs: "4",
          sm: "4",
          lg: "5",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormda105-".concat(variant, "-").concat(formName),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: "d-none d-sm-block ".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
            id: "validationFormda105-label-".concat(variant, "-").concat(formName),
            children: ["Street no.", !validations['streetNo'] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              children: ' (Optional)'
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "streetNo",
            value: fieldValues['streetNo'],
            placeholder: "#",
            onChange: handleChange,
            onBlur: handleBlur,
            readOnly: readOnlyValues['streetNo'],
            isInvalid: fieldErrors['streetNo'],
            className: fieldErrors['streetNo'] ? (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage['streetNo']
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          xs: "8",
          sm: "8",
          lg: "7",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormda106-".concat(variant, "-").concat(formName),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: "d-none d-sm-block ".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
            id: "validationFormda106-label-".concat(variant, "-").concat(formName),
            children: ["Street name", !validations['streetName'] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              children: ' (Optional)'
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "streetName",
            value: fieldValues['streetName'],
            placeholder: "Add street name",
            onChange: handleChange,
            onBlur: handleBlur,
            readOnly: readOnlyValues['streetName'],
            isInvalid: fieldErrors['streetName'],
            className: fieldErrors['streetName'] ? (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage['streetName']
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Row, {
        className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-row"]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
          className: "d-block d-sm-none ".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
          id: "validationFormda107-mob-label-".concat(variant, "-").concat(formName),
          children: "Suburb & Postal code"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          xs: "8",
          sm: "8",
          lg: "7",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormda107-".concat(variant, "-").concat(formName),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: "d-none d-sm-block ".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
            id: "validationFormda107-label-".concat(variant, "-").concat(formName),
            children: "Suburb"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "suburb",
            value: fieldValues['suburb'],
            placeholder: "Add suburb",
            onChange: handleChange,
            onBlur: handleBlur,
            readOnly: readOnlyValues['suburb'],
            isInvalid: fieldErrors['suburb'],
            className: fieldErrors['suburb'] ? (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage['suburb']
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          xs: "4",
          sm: "4",
          lg: "5",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormda108-".concat(variant, "-").concat(formName),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: "d-none d-sm-block ".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
            id: "validationFormda108-label-".concat(variant, "-").concat(formName),
            children: "Postal code"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "postalCode",
            value: fieldValues['postalCode'],
            placeholder: "#",
            maxLength: "4",
            onChange: handleChange,
            onBlur: handleBlur,
            readOnly: readOnlyValues['postalCode'],
            isInvalid: fieldErrors['postalCode'],
            className: fieldErrors['postalCode'] ? (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage['postalCode']
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
        as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
        sm: "12",
        md: "12",
        className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
        controlId: "validationFormda109-".concat(variant, "-").concat(formName),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"]),
          id: "validationFormda109-label-".concat(variant, "-").concat(formName),
          children: "Town / City"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
          type: "text",
          name: "town",
          value: fieldValues['town'],
          placeholder: "Add town / city",
          onChange: handleChange,
          onBlur: handleBlur,
          readOnly: readOnlyValues['town'],
          isInvalid: fieldErrors['town'],
          className: fieldErrors['town'] ? (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : ''
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
          type: "invalid",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
          children: fieldErrorsMessage['town']
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
        as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
        sm: "12",
        md: "12",
        className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
        controlId: "validationFormda110-".concat(variant, "-").concat(formName),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"]),
          id: "validationFormda110-label-".concat(variant, "-").concat(formName),
          children: "Province"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_selectDropDown_SelectDropDown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          formName: formName,
          name: "province",
          label: "Province",
          data: stateTypesOptions,
          handleSelect: handleDropdown,
          selectedId: fieldValues['province'],
          customId: "validationFormda110-".concat(variant, "-").concat(formName),
          fieldError: fieldErrors['province']
        })]
      }), variant !== 'popup' && formName !== 'companyInformation' && !isGuestUser && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
        as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
        sm: "12",
        md: "12",
        className: "".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"])),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Check, {
          custom: true,
          name: "futureCheck",
          label: "Save this address for future purchases",
          onChange: handleChange,
          onBlur: handleBlur,
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-checkbox-label"]),
          id: "validationFormik112-".concat(variant, "-").concat(formName)
        })
      }), variant !== 'popup' && formName !== 'companyInformation' && isGuestUser && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
        as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
        sm: "12",
        md: "12",
        className: "".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"])),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Check, {
          custom: true,
          name: "contactCheck",
          label: "I am the contact person for this address",
          checked: fieldValues['contactCheck'],
          onChange: handleChange,
          onBlur: handleBlur,
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-checkbox-label"]),
          id: "validationFormik113-".concat(variant, "-").concat(formName)
        })
      })]
    })
  });
};

DeliveryAddress.defaultProps = {
  variant: 'plain',
  formName: 'delivery',
  validations: {},
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
  addressTypesOptions: [],
  stateTypesOptions: [],
  isGuestUser: false
};
/* harmony default export */ __webpack_exports__["Z"] = (DeliveryAddress);

/***/ }),

/***/ 81083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _pageHeading_PageHeading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19456);
/* harmony import */ var _pageDescription_PageDescription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5241);
/* harmony import */ var _FormHeading_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76167);
/* harmony import */ var _FormHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_FormHeading_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);







var FormHeading = function FormHeading(_ref) {
  var className = _ref.className,
      headingClassName = _ref.headingClassName,
      descClassName = _ref.descClassName,
      title = _ref.title,
      desc = _ref.desc,
      id = _ref.id;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
    className: "".concat(className, " ").concat((_FormHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["top-wrapper"])),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_pageHeading_PageHeading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      text: title,
      className: "".concat(headingClassName, " ").concat((_FormHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["top-wrapper__heading"])),
      id: "".concat(id, "-heading")
    }), desc && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_pageDescription_PageDescription__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      text: desc,
      className: "".concat(descClassName, " ").concat((_FormHeading_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["top-wrapper__desc"])),
      id: "".concat(id, "-desc")
    })]
  });
};

FormHeading.defaultProps = {
  className: "",
  title: "",
  desc: "",
  id: "form-heading"
};
/* harmony default export */ __webpack_exports__["Z"] = (FormHeading);

/***/ }),

/***/ 83197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12426);
/* harmony import */ var _CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _PersonDetails_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68471);
/* harmony import */ var _PersonDetails_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_PersonDetails_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64036);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








var PersonDetails = function PersonDetails(_ref) {
  var formName = _ref.formName,
      applicationType = _ref.applicationType,
      variant = _ref.variant,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      readOnlyValues = _ref.readOnlyValues,
      onChangeHandler = _ref.onChangeHandler,
      onBlurHandler = _ref.onBlurHandler,
      className = _ref.className,
      isGuestUser = _ref.isGuestUser,
      formInfo = _ref.formInfo;

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
    className: "".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[variant], " ").concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["main-container"]), " ").concat(className),
    children: [formInfo && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
      className: (_PersonDetails_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-info"]),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
        className: (_PersonDetails_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
        src: formInfo === null || formInfo === void 0 ? void 0 : formInfo.icon
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
        id: "form-info-".concat(variant, "-").concat(formName, "-desc"),
        className: (_PersonDetails_module_scss__WEBPACK_IMPORTED_MODULE_4___default().desc),
        children: formInfo === null || formInfo === void 0 ? void 0 : formInfo.desc
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Row, {
      className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["main-row"]),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
        as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
        sm: "12",
        md: "12",
        className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
        controlId: "validationFormpd101-".concat(variant, "-").concat(formName),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"]),
          id: "validationFormpd101-label-".concat(variant, "-").concat(formName),
          children: "First name"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
          type: "text",
          name: "firstName",
          value: fieldValues["firstName"],
          placeholder: "Add your first name",
          onChange: handleChange,
          onBlur: handleBlur,
          readOnly: readOnlyValues["firstName"],
          isInvalid: fieldErrors["firstName"],
          className: fieldErrors["firstName"] ? (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : ""
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
          type: "invalid",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
          children: fieldErrorsMessage["firstName"]
        }), formName == "details" && !fieldErrors["firstName"] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["hint-text"]),
          children: "As it appears on your ID / passport"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
        as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
        sm: "12",
        md: "12",
        className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
        controlId: "validationFormpd102-".concat(variant, "-").concat(formName),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"]),
          id: "validationFormpd102-label-".concat(variant, "-").concat(formName),
          children: "Surname"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
          type: "text",
          name: "surName",
          value: fieldValues["surName"],
          placeholder: "Add your surname",
          onChange: handleChange,
          onBlur: handleBlur,
          readOnly: readOnlyValues["surName"],
          isInvalid: fieldErrors["surName"],
          className: fieldErrors["surName"] ? (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : ""
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
          type: "invalid",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
          children: fieldErrorsMessage["surName"]
        }), formName == "details" && !fieldErrors["surName"] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["hint-text"]),
          children: "As it appears on your ID / passport"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
        as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
        sm: "12",
        md: "12",
        className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
        controlId: "validationFormpd103-".concat(variant, "-").concat(formName),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"]),
          id: "validationFormpd103-label-".concat(variant, "-").concat(formName),
          children: "Cellphone number"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
          type: "text",
          maxLength: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_1__/* .africaCountryCode */ .xJ)(fieldValues["cellNumber"]) ? "11" : "10",
          name: "cellNumber",
          value: fieldValues["cellNumber"],
          placeholder: "Add your cellphone number",
          onChange: handleChange,
          onBlur: handleBlur,
          readOnly: readOnlyValues["cellNumber"],
          isInvalid: fieldErrors["cellNumber"],
          className: fieldErrors["cellNumber"] ? (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : ""
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
          type: "invalid",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
          children: fieldErrorsMessage["cellNumber"]
        })]
      }), formName == "details" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          sm: "12",
          md: "12",
          className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormpd104-".concat(variant, "-").concat(formName),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"]),
            id: "validationFormpd104-label-".concat(variant, "-").concat(formName),
            children: "Email address"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "email",
            name: "email",
            value: fieldValues["email"],
            placeholder: "Add your email address",
            onChange: handleChange,
            onBlur: handleBlur,
            readOnly: readOnlyValues["email"],
            isInvalid: fieldErrors["email"],
            className: fieldErrors["email"] ? (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : ""
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage["email"]
          })]
        }), !isGuestUser && applicationType == "normal" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          sm: "12",
          md: "12",
          className: "".concat((_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]), " ").concat((_PersonDetails_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["contact-check"])),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Check, {
            custom: true,
            name: "contactCheck",
            label: "I am the contact person for this address",
            checked: fieldValues["contactCheck"],
            onChange: handleChange,
            onBlur: handleBlur,
            className: (_CheckoutForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-checkbox-label"]),
            id: "validationFormpd105-".concat(variant, "-").concat(formName)
          })
        })]
      })]
    })]
  });
};

PersonDetails.defaultProps = {
  variant: "plain",
  formName: "details",
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
  isGuestUser: false,
  applicationType: "normal",
  formInfo: null
};
/* harmony default export */ __webpack_exports__["Z"] = (PersonDetails);

/***/ }),

/***/ 31201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28658);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(698);
/* harmony import */ var _SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99599);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









var SelectDropDown = function SelectDropDown(_ref) {
  var formName = _ref.formName,
      data = _ref.data,
      name = _ref.name,
      label = _ref.label,
      resetRequired = _ref.resetRequired,
      customId = _ref.customId,
      customClassName = _ref.customClassName,
      menuClassName = _ref.menuClassName,
      selectedId = _ref.selectedId,
      fieldError = _ref.fieldError,
      handleSelect = _ref.handleSelect,
      handleReset = _ref.handleReset;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      showOptionList = _useState[0],
      setShowOptionList = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      modalShow = _useState2[0],
      setModalShow = _useState2[1];

  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .componentResize */ .Y4)();
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_3___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_3___default().envConfigs)[env].imagePrefix;

  var handleListDisplay = function handleListDisplay() {
    setShowOptionList(function (prevState) {
      return !prevState;
    });

    if (isMobile) {
      setModalShow(true);
    }
  };

  var resetClick = function resetClick() {
    if (handleReset) {
      handleReset(name, formName);
    }

    setShowOptionList(false);
    closeOptions();
  };

  var getValueLabel = function getValueLabel() {
    var item = data.find(function (item) {
      return item.id == selectedId;
    });
    var label = "";

    if (item) {
      if (item.label) {
        label = item.label;
      } else {
        label = item.name;
      }
    }

    return label;
  };

  var handleItemChange = function handleItemChange(event) {
    var eventTarget = event.target;
    var eventCurrentTarget = event.currentTarget;
    var dataId = eventCurrentTarget.getAttribute("data-id");
    var dataIndex = eventCurrentTarget.getAttribute("data-index");
    eventTarget.name = name;
    eventCurrentTarget.name = name;

    if (handleSelect) {
      if (formName) {
        handleSelect(event, dataId, formName, dataIndex);
      } else {
        handleSelect(event, dataId, dataIndex);
      }
    }

    setShowOptionList(function (prevState) {
      return !prevState;
    });
    closeOptions();
  };

  var handleClickOutside = function handleClickOutside(e) {
    if (!e.target.classList.contains((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["select-component"])) && !e.target.classList.contains((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["selected-value"])) && !e.target.classList.contains((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().menu)) && !e.target.classList.contains((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item"])) && !e.target.classList.contains((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item__name"])) && !e.target.classList.contains((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__title)) && !e.target.classList.contains((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__label)) && !e.target.classList.contains((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__reset))) {
      setShowOptionList(false);
      closeOptions();
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Add Event Listner to handle the click that happens outside
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      // Remove the event listner on component unmounting
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  var closeOptions = function closeOptions() {
    setModalShow(false);
  };

  var optionList = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("ul", {
    className: "".concat((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().menu), " ").concat(menuClassName),
    id: "menu-list-".concat(customId),
    children: data.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("li", {
        className: "".concat((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item"]), " ").concat(typeof selectedId !== undefined && selectedId == item.id ? (_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active) : ""),
        "data-id": item.id,
        "data-index": index,
        onClick: function onClick(e) {
          return handleItemChange(e);
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
          className: (_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item__name"]),
          children: item.label ? item.label : item.name
        }), typeof selectedId !== undefined && selectedId == item.id && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
          className: (_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["green-icon"]),
          src: "".concat(imagePrefix, "/assets/images/good.svg")
        })]
      }, index);
    })
  });

  var handleMouse = function handleMouse(e) {
    setShowOptionList(false);
    setModalShow(false);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
    onMouseLeave: handleMouse,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: "".concat((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["select-component"])),
      onClick: handleListDisplay,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("input", {
        type: "text",
        name: name,
        value: getValueLabel(),
        readOnly: true,
        id: customId,
        className: "".concat(fieldError ? "".concat((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["selected-value"]), " ").concat((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().invalid)) : (_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["selected-value"]), " ").concat(customClassName)
      })
    }), showOptionList && !modalShow && optionList, showOptionList && modalShow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Modal, {
      show: modalShow,
      onHide: closeOptions,
      className: (_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal),
      dialogClassName: "select-modal",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "".concat((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__title)),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
          onClick: closeOptions,
          className: (_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__close),
          id: "".concat(label, "_select_modal_close")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
          className: "".concat((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__label)),
          children: label
        }), resetRequired && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
          className: "".concat((_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__reset)),
          onClick: resetClick,
          id: "".concat(label, "-select-modal-reset"),
          children: _config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_reset */ .Z.lbl_reset
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: (_SelectDropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__body),
        children: optionList
      })]
    })]
  });
};

SelectDropDown.defaultProps = {
  data: [],
  name: "select",
  label: "Modal",
  customId: "dropdown-component",
  resetRequired: false,
  fieldError: false
};
/* harmony default export */ __webpack_exports__["Z"] = (SelectDropDown);

/***/ }),

/***/ 62765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57470);
/* harmony import */ var _NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _dropDown_DropDown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67061);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var DeliveryDetailsForm = function DeliveryDetailsForm(_ref) {
  var variant = _ref.variant,
      formName = _ref.formName,
      validations = _ref.validations,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      readOnlyValues = _ref.readOnlyValues,
      addressTypesOptions = _ref.addressTypesOptions,
      stateTypesOptions = _ref.stateTypesOptions,
      onChangeHandler = _ref.onChangeHandler,
      containerClassName = _ref.containerClassName,
      rowClassName = _ref.rowClassName,
      onBlurHandler = _ref.onBlurHandler;
  var BUSINESS_ADDRESS_TYPE = addressTypesOptions && addressTypesOptions.length > 0 && addressTypesOptions[1] ? addressTypesOptions[1].id : "";
  var labels = {
    "default": {
      unitNo: "Unit no.",
      complexName: "Complex name",
      mobUnitNo: "Unit no. & Complex name",
      optional: " (Optional)"
    },
    business: {
      unitNo: "Unit / Floor no.",
      complexName: "Office park / Building name",
      mobUnitNo: "Unit / Floor no. & Office park / Building name",
      optional: " (Optional)"
    }
  };
  var selectedLables = fieldValues["addressType"] == BUSINESS_ADDRESS_TYPE ? labels.business : labels["default"];

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  var onDropdownChange = function onDropdownChange(event) {
    var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var formName = arguments.length > 2 ? arguments[2] : undefined;
    onChangeHandler(event, val, formName);
    onBlurHandler(event, val, formName);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
    className: "".concat((_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[variant], " ").concat((_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["main-container"]), " ").concat(containerClassName),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Row, {
      className: "".concat((_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["main-row"]), " ").concat(rowClassName),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          sm: "12",
          md: "12",
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormdl101-".concat(variant),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"]),
            id: "validationFormdl101-label-".concat(variant),
            children: "Address name"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "addressName",
            value: fieldValues["addressName"],
            placeholder: "Add address name",
            onChange: handleChange,
            readOnly: readOnlyValues["addressName"],
            isInvalid: fieldErrors["addressName"],
            className: fieldErrors["addressName"] ? (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : "",
            onBlur: handleBlur
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage["addressName"]
          }), !fieldErrors["addressName"] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["hint-text"]),
            children: "What you normally call this address (e.g. Home)"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          sm: "12",
          md: "12",
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormdl102-".concat(variant),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"]),
            id: "validationFormdl102-label-".concat(variant),
            children: "Address type"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_dropDown_DropDown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            formName: formName,
            name: "addressType",
            label: "Address type",
            data: addressTypesOptions,
            required: true,
            handleSelect: onDropdownChange,
            selectedId: fieldValues["addressType"],
            customId: "validationFormda102-".concat(variant),
            resetRequired: false,
            fieldError: fieldErrors["addressType"]
          })]
        })]
      }), fieldValues["addressType"] == BUSINESS_ADDRESS_TYPE && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          sm: "12",
          md: "12",
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormdl113-".concat(variant),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"]),
            id: "validationFormdl113-label-".concat(variant),
            children: "Company name"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "companyName",
            value: fieldValues["companyName"],
            placeholder: "Add company name",
            onChange: handleChange,
            readOnly: readOnlyValues["companyName"],
            isInvalid: fieldErrors["companyName"],
            className: fieldErrors["companyName"] ? (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : "",
            onBlur: handleBlur
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage["companyName"]
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Row, {
        className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-row"]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          xs: "12",
          sm: "4",
          md: "4",
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormdl103-".concat(variant),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: "".concat((_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
            id: "validationFormdl103-label-".concat(variant),
            children: [selectedLables.unitNo, !validations["unitNo"] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              children: selectedLables.optional
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "unitNo",
            value: fieldValues["unitNo"],
            placeholder: "#",
            onChange: handleChange,
            readOnly: readOnlyValues["unitNo"],
            isInvalid: fieldErrors["unitNo"],
            className: fieldErrors["unitNo"] ? (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : "",
            onBlur: handleBlur
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage["unitNo"]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          xs: "12",
          sm: "8",
          md: "8",
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormdl104-".concat(variant),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: "".concat((_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
            id: "validationFormdl104-label-".concat(variant),
            children: [selectedLables.complexName, !validations["complexName"] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              children: selectedLables.optional
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "complexName",
            value: fieldValues["complexName"],
            placeholder: "Add complex name",
            onChange: handleChange,
            readOnly: readOnlyValues["complexName"],
            isInvalid: fieldErrors["complexName"],
            className: fieldErrors["complexName"] ? (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : "",
            onBlur: handleBlur
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage["complexName"]
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Row, {
        className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-row"]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          xs: "12",
          sm: "4",
          md: "4",
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormdl105-".concat(variant),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: "".concat((_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
            id: "validationFormdl105-label-".concat(variant),
            children: ["Street no.", !validations["streetNo"] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              children: selectedLables.optional
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "streetNo",
            value: fieldValues["streetNo"],
            placeholder: "#",
            onChange: handleChange,
            readOnly: readOnlyValues["streetNo"],
            isInvalid: fieldErrors["streetNo"],
            className: fieldErrors["streetNo"] ? (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : "",
            onBlur: handleBlur
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage["streetNo"]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          xs: "12",
          sm: "8",
          md: "8",
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormdl106-".concat(variant),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: "".concat((_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
            id: "validationFormdl106-label-".concat(variant),
            children: ["Street name", !validations["streetName"] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              children: selectedLables.optional
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "streetName",
            value: fieldValues["streetName"],
            placeholder: "Add street name",
            onChange: handleChange,
            readOnly: readOnlyValues["streetName"],
            isInvalid: fieldErrors["streetName"],
            className: fieldErrors["streetName"] ? (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : "",
            onBlur: handleBlur
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage["streetName"]
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Row, {
        className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-row"]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          xs: "12",
          sm: "8",
          md: "8",
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormdl107-".concat(variant),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: "".concat((_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
            id: "validationFormdl107-label-".concat(variant),
            children: "Suburb"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "suburb",
            value: fieldValues["suburb"],
            placeholder: "Add suburb",
            onChange: handleChange,
            readOnly: readOnlyValues["suburb"],
            isInvalid: fieldErrors["suburb"],
            className: fieldErrors["suburb"] ? (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : "",
            onBlur: handleBlur
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage["suburb"]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
          as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
          xs: "12",
          sm: "4",
          md: "4",
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
          controlId: "validationFormdl108-".concat(variant),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
            className: "".concat((_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"])),
            id: "validationFormdl108-label-".concat(variant),
            children: "Postal code"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
            type: "text",
            name: "postalCode",
            value: fieldValues["postalCode"],
            placeholder: "#",
            maxLength: "4",
            onChange: handleChange,
            readOnly: readOnlyValues["postalCode"],
            isInvalid: fieldErrors["postalCode"],
            className: fieldErrors["postalCode"] ? (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : "",
            onBlur: handleBlur
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
            type: "invalid",
            className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
            children: fieldErrorsMessage["postalCode"]
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
        as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
        sm: "12",
        md: "12",
        className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
        controlId: "validationFormdl109-".concat(variant),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"]),
          id: "validationFormdl109-label-".concat(variant),
          children: "Town / City"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control, {
          type: "text",
          name: "town",
          value: fieldValues["town"],
          placeholder: "Add town / city",
          onChange: handleChange,
          readOnly: readOnlyValues["town"],
          isInvalid: fieldErrors["town"],
          className: fieldErrors["town"] ? (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().invalid) : "",
          onBlur: handleBlur
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Control.Feedback, {
          type: "invalid",
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["invalid-feedback"]),
          children: fieldErrorsMessage["town"]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
        as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
        sm: "12",
        md: "12",
        className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"]),
        controlId: "validationFormdl110-".concat(variant),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Label, {
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-label"]),
          id: "validationFormdl110-label-".concat(variant),
          children: "Province"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_dropDown_DropDown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          formName: formName,
          name: "province",
          label: "Province",
          data: stateTypesOptions,
          required: true,
          handleSelect: onDropdownChange,
          selectedId: fieldValues["province"],
          customId: "validationFormda110-".concat(variant),
          resetRequired: false,
          fieldError: fieldErrors["province"]
        })]
      }), variant !== "popup" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Group, {
        as: _DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Col,
        sm: "12",
        md: "12",
        className: "".concat((_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-group"])),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Form.Check, {
          custom: true,
          name: "futureCheck",
          label: "Save this address for future purchases",
          checked: fieldValues["futureCheck"],
          onChange: handleChange,
          className: (_NewLineForms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["form-checkbox-label"]),
          id: "validationFormdl114-".concat(variant)
        })
      })]
    })
  });
};

DeliveryDetailsForm.defaultProps = {
  variant: "plain",
  validations: {},
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {},
  addressTypesOptions: [],
  stateTypesOptions: []
};
/* harmony default export */ __webpack_exports__["Z"] = (DeliveryDetailsForm);

/***/ }),

/***/ 67061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _DependencyHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28658);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);
/* harmony import */ var _DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29269);
/* harmony import */ var _DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99599);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);










var DropDown = function DropDown(_ref) {
  var formName = _ref.formName,
      data = _ref.data,
      name = _ref.name,
      label = _ref.label,
      resetRequired = _ref.resetRequired,
      customId = _ref.customId,
      customClassName = _ref.customClassName,
      menuClassName = _ref.menuClassName,
      selectedId = _ref.selectedId,
      fieldError = _ref.fieldError,
      handleSelect = _ref.handleSelect,
      handleReset = _ref.handleReset,
      handleBlur = _ref.handleBlur;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      showOptionList = _useState[0],
      setShowOptionList = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      modalShow = _useState2[0],
      setModalShow = _useState2[1];

  var isMobile = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .componentResize */ .Y4)();
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_3___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_3___default().envConfigs)[env].imagePrefix;

  var handleListDisplay = function handleListDisplay() {
    setShowOptionList(function (prevState) {
      return !prevState;
    });

    if (isMobile) {
      setModalShow(true);
    }

    isMobile ? document.body.classList.add("no-scroll") : document.body.classList.remove("no-scroll");
  };

  var resetClick = function resetClick() {
    if (handleReset) {
      handleReset(name, formName);
    }

    setShowOptionList(false);
    closeOptions();
  };

  var getValueLabel = function getValueLabel() {
    var item = data.find(function (item) {
      return item.id == selectedId;
    });
    var label = "";

    if (item) {
      if (item.label) {
        label = item.label;
      } else {
        label = item.name;
      }
    }

    return label;
  };

  var handleItemChange = function handleItemChange(event) {
    var eventTarget = event.target;
    var eventCurrentTarget = event.currentTarget;
    var dataId = eventCurrentTarget.getAttribute("data-id");
    var dataIndex = eventCurrentTarget.getAttribute("data-index");
    eventTarget.name = name;
    eventCurrentTarget.name = name;

    if (handleSelect) {
      if (formName) {
        handleSelect(event, dataId, formName, dataIndex);
      } else {
        handleSelect(event, dataId, dataIndex);
      }
    }

    if (handleBlur) {
      if (formName) {
        handleBlur(event, dataId, formName, dataIndex);
      } else {
        handleBlur(event, dataId, dataIndex);
      }
    }

    setShowOptionList(function (prevState) {
      return !prevState;
    });
    closeOptions();
  };

  var handleClickOutside = function handleClickOutside(e) {
    if (!e.target.classList.contains((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["select-component"])) && !e.target.classList.contains((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["selected-value"])) && !e.target.classList.contains((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().menu)) && !e.target.classList.contains((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item"])) && !e.target.classList.contains((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item__name"])) && !e.target.classList.contains((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__title)) && !e.target.classList.contains((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__label)) && !e.target.classList.contains((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__reset))) {
      setShowOptionList(false);
      document.body.classList.remove("no-scroll");
      closeOptions();
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    // Add Event Listner to handle the click that happens outside
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      // Remove the event listner on component unmounting
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  var closeOptions = function closeOptions() {
    setModalShow(false);
  };

  var optionList = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("ul", {
    className: "".concat((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().menu), " ").concat(menuClassName),
    id: "menu-list-".concat(customId),
    children: data.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("li", {
        className: "".concat((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item"]), " ").concat(typeof selectedId !== undefined && selectedId == item.id ? (_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active) : ""),
        "data-id": item.id,
        "data-index": index,
        onClick: function onClick(e) {
          return handleItemChange(e);
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
          className: (_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item__name"]),
          children: item.label ? item.label : item.name
        }), typeof selectedId !== undefined && selectedId == item.id && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("img", {
          className: (_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["green-icon"]),
          src: "".concat(imagePrefix, "/assets/images/icon-green-tick.svg")
        })]
      }, index);
    })
  });

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      onClick: handleListDisplay,
      className: "".concat((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["select-component"])),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("input", {
        type: "text",
        name: name,
        placeholder: "- Select -",
        value: getValueLabel(),
        readOnly: true,
        id: customId,
        className: "".concat(fieldError ? "".concat((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["selected-value"]), " ").concat((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().invalid)) : (_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["selected-value"]), " ").concat(customClassName),
        onBlur: handleBlur
      })
    }), showOptionList && !modalShow && optionList, showOptionList && modalShow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_DependencyHelper__WEBPACK_IMPORTED_MODULE_1__.Modal, {
      show: modalShow,
      onHide: closeOptions,
      className: (_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal),
      dialogClassName: "select-modal",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: "".concat((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__title)),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
          onClick: closeOptions,
          className: (_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__close),
          id: "".concat(label, "_select_modal_close")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
          className: "".concat((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__label)),
          children: label
        }), resetRequired && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
          className: "".concat((_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__reset)),
          onClick: resetClick,
          id: "".concat(label, "-select-modal-reset"),
          children: _config_labels__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lbl_reset */ .Z.lbl_reset
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: (_DropDown_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modal__body),
        children: optionList
      })]
    })]
  });
};

DropDown.defaultProps = {
  data: [],
  label: "Modal",
  resetRequired: false,
  name: "select",
  fieldError: false,
  customId: "dropdown-component"
};
/* harmony default export */ __webpack_exports__["Z"] = (DropDown);

/***/ }),

/***/ 5241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var _PageDescription_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57289);
/* harmony import */ var _PageDescription_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PageDescription_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64036);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var PageDescription = function PageDescription(_ref) {
  var text = _ref.text,
      className = _ref.className,
      id = _ref.id;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    className: "".concat((_PageDescription_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["page-description"]), " ").concat(className),
    id: id,
    dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .createMarkup */ .KU)(text)
  }, "id", id));
};

PageDescription.defaultProps = {
  text: "",
  className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (PageDescription);

/***/ }),

/***/ 23060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ checkoutFormsModal_CheckoutFormsModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./components/atoms/buttons/buttonWithIcon/ButtonWithIcon.jsx
var ButtonWithIcon = __webpack_require__(30390);
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton = __webpack_require__(79549);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/deliveryAddress/DeliveryAddress.jsx
var DeliveryAddress = __webpack_require__(75178);
// EXTERNAL MODULE: ./components/atoms/newLineForms/creditCheckForms/deliveryDetailsForm/DeliveryDetailsForm.jsx
var DeliveryDetailsForm = __webpack_require__(62765);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/personDetails/PersonDetails.jsx
var PersonDetails = __webpack_require__(83197);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/CheckoutForms.module.scss
var CheckoutForms_module = __webpack_require__(12426);
var CheckoutForms_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutForms_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/checkoutForms/specialInstruction/SpecialInstruction.jsx





var SpecialInstruction = function SpecialInstruction(_ref) {
  var formName = _ref.formName,
      variant = _ref.variant,
      fieldValues = _ref.fieldValues,
      fieldErrors = _ref.fieldErrors,
      fieldErrorsMessage = _ref.fieldErrorsMessage,
      readOnlyValues = _ref.readOnlyValues,
      onChangeHandler = _ref.onChangeHandler,
      onBlurHandler = _ref.onBlurHandler,
      className = _ref.className;

  var handleChange = function handleChange(event) {
    onChangeHandler(event, null, formName);
  };

  var handleBlur = function handleBlur(event) {
    onBlurHandler(event, null, formName);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
    className: "".concat((CheckoutForms_module_default())[variant], " ").concat((CheckoutForms_module_default())["main-container"], " ").concat(className),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Row, {
      className: (CheckoutForms_module_default())["main-row"],
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form.Group, {
        as: DependencyHelper.Col,
        sm: "12",
        md: "12",
        className: (CheckoutForms_module_default())["form-group"],
        controlId: "validationFormsi101-".concat(variant),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control, {
          as: "textarea",
          name: "instructions",
          placeholder: "e.g. Please call me when you're at the gate",
          value: fieldValues["instructions"],
          onChange: handleChange,
          onBlur: handleBlur,
          readOnly: readOnlyValues["instructions"],
          isInvalid: fieldErrors["instructions"],
          className: fieldErrors.instructions ? "".concat((CheckoutForms_module_default())["form-control-area"], " ").concat((CheckoutForms_module_default()).invalid) : (CheckoutForms_module_default())["form-control-area"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Form.Control.Feedback, {
          type: "invalid",
          className: (CheckoutForms_module_default())["invalid-feedback"],
          children: fieldErrorsMessage["instructions"]
        }), !fieldErrors["instructions"] && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (CheckoutForms_module_default())["hint-text"],
          children: "Deliveries are made on weekdays between 08:00 and 17:00"
        })]
      })
    })
  });
};

SpecialInstruction.defaultProps = {
  formName: "instructions",
  variant: "plain",
  fieldValues: {},
  fieldErrors: {},
  fieldErrorsMessage: {},
  readOnlyValues: {}
};
/* harmony default export */ var specialInstruction_SpecialInstruction = (SpecialInstruction);
// EXTERNAL MODULE: ./components/atoms/checkoutForms/formHeading/FormHeading.jsx
var FormHeading = __webpack_require__(81083);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./components/atoms/contentSearchBox/ContentSearchBox.jsx
var ContentSearchBox = __webpack_require__(13616);
// EXTERNAL MODULE: ./components/atoms/confirmModal/ConfirmModal.jsx
var ConfirmModal = __webpack_require__(74183);
// EXTERNAL MODULE: ./services/checkoutService.js
var checkoutService = __webpack_require__(34020);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./config/errorMessages.js
var errorMessages = __webpack_require__(72210);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./components/molecules/modals/checkoutFormsModal/CheckoutFormsModal.module.scss
var CheckoutFormsModal_module = __webpack_require__(45431);
var CheckoutFormsModal_module_default = /*#__PURE__*/__webpack_require__.n(CheckoutFormsModal_module);
;// CONCATENATED MODULE: ./components/molecules/modals/checkoutFormsModal/CheckoutFormsModal.jsx




function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var CheckoutFormsModal = function CheckoutFormsModal(_ref) {
  var show = _ref.show,
      hide = _ref.hide,
      formType = _ref.formType,
      variant = _ref.variant,
      values = _ref.values,
      addressTypes = _ref.addressTypes,
      statesTypes = _ref.statesTypes,
      countryCode = _ref.countryCode,
      cartId = _ref.cartId,
      step = _ref.step,
      deleteOption = _ref.deleteOption,
      pageName = _ref.pageName,
      isGuestUser = _ref.isGuestUser,
      applicationType = _ref.applicationType;

  var _useState = (0,react.useState)(false),
      validated = _useState[0],
      setValidated = _useState[1];

  var _useState2 = (0,react.useState)(true),
      submitDisabled = _useState2[0],
      setSubmitDisabled = _useState2[1];

  var addressTypesOptions = addressTypes ? addressTypes : [];
  var stateTypesOptions = statesTypes ? statesTypes : [];
  var RESIDENTIAL_ADDRESS_TYPE = addressTypesOptions && addressTypesOptions.length > 0 && addressTypesOptions[0] ? addressTypesOptions[0].id : "";
  var BUSINESS_ADDRESS_TYPE = addressTypesOptions && addressTypesOptions.length > 0 && addressTypesOptions[1] ? addressTypesOptions[1].id : "";
  var POSTAL_ADDRESS_TYPE = addressTypesOptions && addressTypesOptions.length > 0 && addressTypesOptions[2] ? addressTypesOptions[2].id : "";

  var _useState3 = (0,react.useState)(false),
      showConfirmModal = _useState3[0],
      setShowConfirmModal = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      confirmModalContent = _useState4[0],
      setConfirmModalContent = _useState4[1];

  var _useState5 = (0,react.useState)(null),
      deleteId = _useState5[0],
      setDeleteId = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      finalAddress = _useState6[0],
      setFinalAddress = _useState6[1];

  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var numRegEx = RegExp(/^[0-9]*$/);
  var cellPhoneRegEx = RegExp(/^0|27[0-9]*$/);
  var streetNameRegEx = RegExp(/^[a-zA-Z0-9_ ]*$/);
  var emailRegEx = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
  var analyticsData = analyticsUtag/* getUtagData */.GS();

  var createStreetString = function createStreetString(arr) {
    var res = "";

    if (Array.isArray(arr) && arr.length > 0) {
      res = arr.join(", ");
    }

    return res;
  };

  var seperateStreetString = function seperateStreetString(str) {
    if (str && str !== "") {
      return str.split(", ");
    } else {
      return null;
    }
  };

  var getRegionValue = function getRegionValue(id) {
    return id && id !== "" ? statesTypes.find(function (item) {
      return item.id == id;
    }) : null;
  };

  var getProvinceValue = function getProvinceValue(name) {
    var finalID = statesTypes.filter(function (item) {
      return item.code == name;
    });

    if (finalID && finalID[0] && finalID[0].id) {
      return finalID[0].id;
    }
  };

  var createStreetFromAddressLines = function createStreetFromAddressLines(str1, str2) {
    var res = [];

    if (str1) {
      res.push(str1);
    }

    if (str2) {
      res.push(str2);
    }

    return res;
  };

  var _useState7 = (0,react.useState)({
    validationsOn: {
      delivery: false,
      billing: false,
      details: false,
      contactDetails: false,
      instructions: false
    },
    errorStatus: {
      delivery: false,
      billing: false,
      details: false,
      contactDetails: false,
      instructions: false
    },
    validations: {
      delivery: {
        addressName: true,
        addressType: true,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: true,
        suburb: true,
        postalCode: true,
        town: true,
        province: true,
        instructions: false
      },
      billing: {
        addressName: true,
        addressType: true,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: true,
        suburb: true,
        postalCode: true,
        town: true,
        province: true,
        instructions: false
      },
      details: {
        firstName: true,
        surName: true,
        cellNumber: true,
        email: true
      },
      contactDetails: {
        firstName: true,
        surName: true,
        cellNumber: true
      },
      instructions: {
        instructions: true
      }
    },
    fieldErrors: {
      delivery: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false
      },
      billing: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false
      },
      details: {
        firstName: false,
        surName: false,
        cellNumber: false,
        email: false
      },
      contactDetails: {
        firstName: false,
        surName: false,
        cellNumber: false
      },
      instructions: {
        instructions: false
      },
      fail: false
    },
    fieldValues: {
      delivery: {
        addressName: "",
        addressType: "",
        companyName: "",
        addressLine1: "",
        addressLine2: "",
        unitNo: "",
        complexName: "",
        streetNo: "",
        streetName: "",
        suburb: "",
        postalCode: "",
        town: "",
        province: "",
        instructions: ""
      },
      billing: {
        addressName: "",
        addressType: "",
        companyName: "",
        addressLine1: "",
        addressLine2: "",
        unitNo: "",
        complexName: "",
        streetNo: "",
        streetName: "",
        suburb: "",
        postalCode: "",
        town: "",
        province: "",
        instructions: ""
      },
      details: {
        firstName: "",
        surName: "",
        cellNumber: "",
        email: ""
      },
      contactDetails: {
        firstName: "",
        surName: "",
        cellNumber: ""
      },
      instructions: {
        instructions: ""
      }
    },
    readOnlyValues: {
      delivery: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false
      },
      billing: {
        addressName: false,
        addressType: false,
        companyName: false,
        addressLine1: false,
        addressLine2: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false
      },
      details: {
        firstName: false,
        surName: false,
        cellNumber: false,
        email: false
      },
      contactDetails: {
        firstName: false,
        surName: false,
        cellNumber: false
      },
      instructions: {
        instructions: false
      }
    },
    fieldErrorsMessage: {
      delivery: {
        addressName: "Please enter a name for this address",
        addressType: "Please select your address type",
        companyName: "Please enter your company name",
        addressLine1: "Please enter your postal address(Line 1)",
        addressLine2: "Please enter your postal address(Line 2)",
        unitNo: "Please enter a unit no.",
        floorNo: "Please enter a unit / floor no.",
        complexName: "Please enter your complex name",
        officeComplexName: "Please enter your office park / building name",
        streetNo: "Please enter your street no.",
        streetName: "Please enter your street name",
        suburb: "Please enter and select suburb",
        postalCode: "Please enter your postal code",
        town: "Please enter your town/city name",
        province: "Please select your province",
        instructions: "Please enter special instructions"
      },
      billing: {
        addressName: "Please enter a name for this address",
        addressType: "Please select your address type",
        companyName: "Please enter your company name",
        addressLine1: "Please enter your postal address(Line 1)",
        addressLine2: "Please enter your postal address(Line 2)",
        unitNo: "Please enter a unit no.",
        floorNo: "Please enter a unit / floor no.",
        complexName: "Please enter your complex name",
        officeComplexName: "Please enter your office park / building name",
        streetNo: "Please enter your street no.",
        streetName: "Please enter your street name",
        suburb: "Please enter and select suburb",
        postalCode: "Please enter your postal code",
        town: "Please enter your town/city name",
        province: "Please select your province",
        instructions: "Please enter special instructions"
      },
      details: {
        firstName: "Please enter your first name",
        surName: "Please enter your surname",
        cellNumber: "Please enter your cellphone number",
        email: "Please enter your email address"
      },
      contactDetails: {
        firstName: "Please enter your first name",
        surName: "Please enter your surname",
        cellNumber: "Please enter a cellphone number"
      },
      instructions: {
        instructions: "Please enter special instructions"
      }
    }
  }),
      state = _useState7[0],
      setState = _useState7[1];

  var validationsOn = state.validationsOn,
      errorStatus = state.errorStatus,
      validations = state.validations,
      fieldErrors = state.fieldErrors,
      fieldValues = state.fieldValues,
      readOnlyValues = state.readOnlyValues,
      fieldErrorsMessage = state.fieldErrorsMessage;

  function setValidationsOn() {
    if (formType) {
      validationsOn[formType] = true;
      errorStatus[formType] = checkFormError(formType);

      if (formType == "delivery") {
        if (variant !== "change") {
          validationsOn.contactDetails = true;
          errorStatus.contactDetails = checkFormError("contactDetails");
        }
      }
    }

    setState(_objectSpread(_objectSpread({}, state), {}, {
      validationsOn: validationsOn,
      errorStatus: errorStatus
    }));
  }

  function mapFormData() {
    var formData = {
      addressName: "",
      addressType: "",
      companyName: "",
      addressLine1: "",
      addressLine2: "",
      unitNo: "",
      complexName: "",
      streetNo: "",
      streetName: "",
      suburb: "",
      postalCode: "",
      town: "",
      province: "",
      instructions: "",
      futureCheck: false
    };

    if (values) {
      formData.addressName = values.address_name ? values.address_name : "";
      formData.addressType = values.address_type_name ? values.address_type_name : addressTypesOptions && addressTypesOptions.length > 0 ? addressTypesOptions[0].id : "";
      formData.companyName = values.company ? values.company : "";
      formData.addressLine1 = values.street && values.street[0] ? values.street[0] : "";
      formData.addressLine2 = values.street && values.street[1] ? values.street[1] : "";
      formData.unitNo = values.unit_number ? values.unit_number : "";
      formData.complexName = values.complex_name ? values.complex_name : "";
      formData.streetNo = values.street_number ? values.street_number : "";
      formData.streetName = values.street ? createStreetString(values.street) : "";
      formData.suburb = values.suburb ? values.suburb : "";
      formData.postalCode = values.postcode ? values.postcode : "";
      formData.town = values.city ? values.city : "";
      formData.province = values.region ? values.region.region_id : stateTypesOptions && stateTypesOptions.length > 0 ? stateTypesOptions[0].id : "";
      formData.instructions = values.instructions ? values.instructions : "";
      formData.futureCheck = isGuestUser ? false : variant == "add" || values !== null && values !== void 0 && values.id || values !== null && values !== void 0 && values.customer_address_id ? true : false;
    }

    return formData;
  }

  (0,react.useEffect)(function () {
    // Set initial state of form values
    if (show) {
      if (variant == "edit" || variant == "change") {
        var formData = mapFormData();

        if (formType == "delivery" || formType == "billing") {
          fieldValues[formType].addressName = formData.addressName;
          fieldValues[formType].addressType = formData.addressType;
          fieldValues[formType].companyName = formData.companyName;
          fieldValues[formType].addressLine1 = formData.addressLine1;
          fieldValues[formType].addressLine2 = formData.addressLine2;
          fieldValues[formType].unitNo = formData.unitNo;
          fieldValues[formType].complexName = formData.complexName;
          fieldValues[formType].streetNo = formData.streetNo;
          fieldValues[formType].streetName = formData.streetName;
          fieldValues[formType].suburb = formData.suburb;
          fieldValues[formType].postalCode = formData.postalCode;
          fieldValues[formType].town = formData.town;
          fieldValues[formType].province = formData.province;
        }

        if (formType == "delivery" || formType == "billing" || formType == "instructions") {
          fieldValues[formType].instructions = formData.instructions;
        }

        if (formType == "delivery" || formType == "contactDetails") {
          fieldValues.contactDetails.firstName = values.firstname ? values.firstname : "";
          fieldValues.contactDetails.surName = values.lastname ? values.lastname : "";
          fieldValues.contactDetails.cellNumber = values.telephone ? values.telephone : "";
        } else {
          fieldValues.details.firstName = values.firstname ? values.firstname : "";
          fieldValues.details.surName = values.lastname ? values.lastname : "";
          fieldValues.details.cellNumber = values.telephone ? values.telephone : "";
        }

        fieldValues.details.email = values.email ? values.email : "";

        if (formType == "delivery" || formType == "billing") {
          validations[formType].companyName = false;
          validations[formType].addressLine1 = false;
          validations[formType].addressLine2 = false;
          validations[formType].unitNo = !!fieldValues[formType].complexName;
          validations[formType].complexName = false;
          validations[formType].streetNo = false;
          validations[formType].streetName = true;

          if (fieldValues[formType].addressType == POSTAL_ADDRESS_TYPE) {
            validations[formType].streetName = false;
            validations[formType].addressLine1 = true;
            validations[formType].addressLine2 = true;
          } else if (fieldValues[formType].addressType == BUSINESS_ADDRESS_TYPE) {
            validations[formType].companyName = true;
            validations[formType].unitNo = true;
            validations[formType].complexName = true;
            validations[formType].streetNo = true;
          }
        }

        setState(_objectSpread(_objectSpread({}, state), {}, {
          validations: validations,
          fieldValues: fieldValues
        })); //Button enable on edit

        setSubmitDisabled(false);
      } else {
        refreshState();
      }

      setValidationsOn();
    }
  }, [show]);
  (0,react.useEffect)(function () {
    addressSearchResultMap();
  }, [finalAddress]);
  var dataObject = {
    delivery: {
      title: "Delivery address",
      desc: "Where would you like us to deliver your order?"
    },
    billing: {
      title: "Billing address",
      desc: "Where would you like us to send your bill?"
    },
    details: {
      title: "Contact details",
      desc: "Who can we contact when we deliver at this address?"
    },
    contactDetails: {
      title: "Contact details",
      desc: "Who can we contact when we deliver at this address?"
    },
    instructions: {
      title: "Special instructions",
      desc: "Is there anything our courier needs to take into account when delivering your order?"
    }
  };
  var addVariantObject = {
    delivery: {
      modalTitle: "Add a delivery address",
      buttonLabel: "Save address"
    },
    billing: {
      modalTitle: "Add a billing address",
      buttonLabel: "Save address"
    },
    details: {
      modalTitle: "Add contact details",
      buttonLabel: "Save details"
    },
    contactDetails: {
      modalTitle: "Add contact details",
      buttonLabel: "Save details"
    },
    instructions: {
      modalTitle: "Add special instructions",
      buttonLabel: "Save"
    }
  };
  var editVariantObject = {
    delivery: {
      modalTitle: "Edit your delivery address",
      buttonLabel: "Update address"
    },
    billing: {
      modalTitle: "Edit your billing address",
      buttonLabel: "Update address"
    },
    details: {
      modalTitle: "Edit contact details",
      buttonLabel: "Update"
    },
    contactDetails: {
      modalTitle: "Edit contact details",
      buttonLabel: "Update"
    },
    instructions: {
      modalTitle: "Edit special instructions",
      buttonLabel: "Update"
    }
  };
  var changeVariantObject = {
    delivery: {
      modalTitle: "Change delivery address",
      buttonLabel: "Update address"
    },
    billing: {
      modalTitle: "Change billing address",
      buttonLabel: "Update address"
    },
    details: {
      modalTitle: "Change contact details",
      buttonLabel: "Update"
    },
    contactDetails: {
      modalTitle: "Change contact details",
      buttonLabel: "Update"
    },
    instructions: {
      modalTitle: "Change special instructions",
      buttonLabel: "Update"
    }
  };

  var modalClose = function modalClose(refresh, results) {
    refreshState();
    (0,helperServices/* hideSpinner */.v3)();
    hide(refresh, results);
  };

  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.persist();

    if (!checkEntireFormError()) {
      var linkType = getAnalyticsLinkType();
      analyticsUtag/* link */.p4(_objectSpread(_objectSpread({
        page_name: "".concat(pageName)
      }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
        visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
        link_type: "o",
        link_name: "".concat(pageName, ": ").concat(variant, " ").concat(linkType, ": submit")
      }));
      addEditAddress();
    } else {
      event.stopPropagation();
    }
  };
  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */


  var handleBlur = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(event, val, form) {
      var name;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.persist();
              name = event.target.name;
              _context.next = 4;
              return fieldValidationCheck(name, val, form, event);

            case 4:
              if (!(name === "complexName")) {
                _context.next = 7;
                break;
              }

              _context.next = 7;
              return fieldValidationCheck("unitNo", state.fieldValues[form].unitNo, form, event);

            case 7:
              if (name == "addressType") {
                // Check form validation because field validation updated
                multipleFieldsValidationCheck(["companyName", "addressLine1", "addressLine2", "unitNo", "complexName", "streetNo", "streetName"], form, event);
              }

              _context.next = 10;
              return checkFormError(form);

            case 10:
              errorStatus[form] = _context.sent;
              setState(_objectSpread(_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (state.fieldErrors.fail) {
                setSubmitDisabled(true);
              } else {
                checkErrorStatus();
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleBlur(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Form input field change event handler
   *
   * @usage call updateFieldValues function
   * @call onChange event
   */


  var handleChange = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, val, form) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return updateFieldValues(event, val, form);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x4, _x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * update input field values
   *
   * @usage Set the state of form validations, fieldValues
   */


  var updateFieldValues = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(event, val, form) {
      var name, value, selectionName;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              name = event.target.name;
              value = val ? val : event.target.value;

              if (name == "addressType") {
                validations[form].companyName = false;
                validations[form].addressLine1 = false;
                validations[form].addressLine2 = false;
                validations[form].unitNo = false;
                validations[form].complexName = false;
                validations[form].streetNo = false;
                validations[form].streetName = true;

                if (value == POSTAL_ADDRESS_TYPE) {
                  validations[form].streetName = false;
                  validations[form].addressLine1 = true;
                  validations[form].addressLine2 = true;

                  if (fieldValues[form].addressLine1 == "" || fieldValues[form].addressLine2 == "") {
                    fieldErrors.fail = true;
                  } else {
                    fieldErrors.fail = false;
                  }
                } else if (value == BUSINESS_ADDRESS_TYPE) {
                  validations[form].companyName = true;
                  validations[form].unitNo = true;
                  validations[form].complexName = true;
                  validations[form].streetNo = true;

                  if (fieldValues[form].companyName == "" || fieldValues[form].unitNo == "" || fieldValues[form].complexName == "" || fieldValues[form].streetNo == "" || fieldValues[form].streetName == "") {
                    fieldErrors.fail = true;
                  } else {
                    fieldErrors.fail = false;
                  }
                }
              }

              fieldValues[form][name] = value;

              if (!(name == "addressType" || name == "province")) {
                _context3.next = 12;
                break;
              }

              selectionName = name;
              _context3.t0 = name;
              _context3.next = _context3.t0 === "addressType" ? 9 : 11;
              break;

            case 9:
              selectionName = "address type";
              return _context3.abrupt("break", 11);

            case 11:
              //capture analytics user selects addressType, province, futureCheck
              selectionAnalytics(selectionName, fieldValues[form][name]);

            case 12:
              setState(_objectSpread(_objectSpread({}, state), {}, {
                validations: validations,
                fieldErrors: fieldErrors,
                fieldValues: fieldValues
              }));

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function updateFieldValues(_x7, _x8, _x9) {
      return _ref4.apply(this, arguments);
    };
  }();

  var multipleFieldsValidationCheck = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(fieldsArray, form, event) {
      var values, errors, entries, i;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              values = state.fieldValues[form];
              errors = state.fieldErrors[form];
              entries = fieldsArray.length;

              if (state.validationsOn[form]) {
                for (i = 0; i < entries; i++) {
                  if (values[fieldsArray[i]] !== "" || errors[fieldsArray[i]]) {
                    fieldValidationCheck(fieldsArray[i], values[fieldsArray[i]], form, event);
                  }
                }
              }

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function multipleFieldsValidationCheck(_x10, _x11, _x12) {
      return _ref5.apply(this, arguments);
    };
  }();

  var fieldValidationCheck = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(name, val, form, event) {
      var value;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              value = val ? val : event.target.value;
              _context5.t0 = name;
              _context5.next = _context5.t0 === "addressName" ? 4 : _context5.t0 === "addressType" ? 6 : _context5.t0 === "companyName" ? 8 : _context5.t0 === "addressLine1" ? 10 : _context5.t0 === "addressLine2" ? 12 : _context5.t0 === "unitNo" ? 14 : _context5.t0 === "complexName" ? 17 : _context5.t0 === "streetNo" ? 21 : _context5.t0 === "streetName" ? 24 : _context5.t0 === "suburb" ? 26 : _context5.t0 === "town" ? 28 : _context5.t0 === "postalCode" ? 30 : _context5.t0 === "province" ? 32 : _context5.t0 === "firstName" ? 34 : _context5.t0 === "surName" ? 36 : _context5.t0 === "cellNumber" ? 38 : _context5.t0 === "email" ? 40 : _context5.t0 === "instructions" ? 42 : 44;
              break;

            case 4:
              if (state.validationsOn[form] && state.validations[form].addressName) {
                fieldErrors[form].addressName = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].addressName;
              } else {
                fieldErrors[form].addressName = false;
              }

              return _context5.abrupt("break", 44);

            case 6:
              if (state.validationsOn[form] && state.validations[form].addressType) {
                fieldErrors[form].addressType = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].addressType;
              } else {
                fieldErrors.addressType = false;
              }

              return _context5.abrupt("break", 44);

            case 8:
              if (state.validationsOn[form] && state.validations[form].companyName) {
                fieldErrors[form].companyName = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].companyName;
              } else {
                fieldErrors[form].companyName = false;
              }

              return _context5.abrupt("break", 44);

            case 10:
              if (state.validationsOn[form] && state.validations[form].addressLine1) {
                fieldErrors[form].addressLine1 = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].addressLine1;
              } else {
                fieldErrors[form].addressLine1 = false;
              }

              return _context5.abrupt("break", 44);

            case 12:
              if (state.validationsOn[form] && state.validations[form].addressLine2) {
                fieldErrors[form].addressLine2 = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].addressLine2;
              } else {
                fieldErrors[form].addressLine2 = false;
              }

              return _context5.abrupt("break", 44);

            case 14:
              if (value.length > 0) {
                fieldErrors[form].unitNo = numRegEx.test(value) ? false : true;

                if (fieldErrors[form].unitNo) {
                  if (state.fieldValues[form].addressType == BUSINESS_ADDRESS_TYPE) {
                    fieldErrorsMessage[form].unitNo = errorMessages/* default.checkout */.Z.checkout[form].floorNo.onlyNumber;
                  } else {
                    fieldErrorsMessage[form].unitNo = errorMessages/* default.checkout */.Z.checkout[form].unitNo.onlyNumber;
                  }
                }
              } else {
                if (state.validationsOn[form] && state.validations[form].unitNo) {
                  fieldErrors[form].unitNo = true;
                } else {
                  fieldErrors[form].unitNo = false;
                }

                if (state.fieldValues[form].addressType == BUSINESS_ADDRESS_TYPE) {
                  fieldErrorsMessage[form].unitNo = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].floorNo;
                } else {
                  fieldErrorsMessage[form].unitNo = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].unitNo;
                }
              }

              fieldErrors.fail = fieldErrors[form].unitNo;
              return _context5.abrupt("break", 44);

            case 17:
              if (state.validationsOn[form] && state.validations[form].complexName) {
                fieldErrors[form].complexName = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].complexName;

                if (state.fieldValues.addressType == BUSINESS_ADDRESS_TYPE) {
                  fieldErrorsMessage[form].complexName = state.fieldErrorsMessage[form].officeComplexName;
                } else {
                  fieldErrorsMessage[form].complexName = state.fieldErrorsMessage[form].complexName;
                }
              } else {
                fieldErrors[form].complexName = false;
              }

              if (state.fieldValues[form].complexName !== "") {
                state.validations.delivery.unitNo = true;
              }

              if (state.fieldValues[form].complexName == "") {
                state.validations.delivery.unitNo = false;
              }

              return _context5.abrupt("break", 44);

            case 21:
              if (value.length > 0) {
                fieldErrors[form].streetNo = numRegEx.test(value) ? false : true;

                if (fieldErrors[form].streetNo) {
                  fieldErrorsMessage[form].streetNo = errorMessages/* default.checkout */.Z.checkout[form].streetNo.onlyValid;
                }
              } else {
                if (state.validationsOn[form] && state.validations[form].streetNo) {
                  fieldErrors[form].streetNo = true;
                } else {
                  fieldErrors[form].streetNo = false;
                }

                fieldErrorsMessage[form].streetNo = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].streetNo;
              }

              fieldErrors.fail = fieldErrors[form].streetNo;
              return _context5.abrupt("break", 44);

            case 24:
              if (state.validationsOn[form] && state.validations[form].streetName) {
                if (value.length > 0) {
                  if (!streetNameRegEx.test(value)) {
                    fieldErrors[form].streetName = true;
                    fieldErrorsMessage[form].streetName = errorMessages/* default.checkout */.Z.checkout[form].streetName.onlyValid;
                  } else {
                    fieldErrors[form].streetName = false;
                  }
                } else {
                  fieldErrors[form].streetName = true;
                  fieldErrorsMessage[form].streetName = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].streetName;
                }

                fieldErrors.fail = fieldErrors[form].streetName;
              } else {
                fieldErrors[form].streetName = false;
              }

              return _context5.abrupt("break", 44);

            case 26:
              if (state.validationsOn[form] && state.validations[form].suburb) {
                fieldErrors[form].suburb = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].suburb;
              } else {
                fieldErrors[form].suburb = false;
              }

              return _context5.abrupt("break", 44);

            case 28:
              if (state.validationsOn[form] && state.validations[form].town) {
                fieldErrors[form].town = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].town;
              } else {
                fieldErrors[form].town = false;
              }

              return _context5.abrupt("break", 44);

            case 30:
              if (state.validationsOn[form] && state.validations[form].postalCode) {
                if (value.length > 0) {
                  if (!numRegEx.test(value)) {
                    fieldErrors[form].postalCode = true;
                    fieldErrorsMessage[form].postalCode = errorMessages/* default.checkout */.Z.checkout[form].postalCode.onlyNumber;
                  } else if (value.length < 4) {
                    fieldErrors[form].postalCode = true;
                    fieldErrorsMessage[form].postalCode = errorMessages/* default.checkout */.Z.checkout[form].postalCode.onlyValid;
                  } else {
                    fieldErrors[form].postalCode = false;
                  }
                } else {
                  fieldErrors[form].postalCode = true;
                  fieldErrorsMessage[form].postalCode = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].postalCode;
                }

                fieldErrors.fail = fieldErrors[form].postalCode;
              } else {
                fieldErrors[form].postalCode = false;
              }

              return _context5.abrupt("break", 44);

            case 32:
              if (state.validationsOn[form] && state.validations[form].province) {
                fieldErrors[form].province = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].province;
              } else {
                fieldErrors[form].province = false;
              }

              return _context5.abrupt("break", 44);

            case 34:
              if (state.validationsOn[form] && state.validations[form].firstName) {
                if (value.length > 0) {
                  if (value.length <= 2) {
                    fieldErrors[form].firstName = true;
                    fieldErrorsMessage[form].firstName = errorMessages/* default.checkout */.Z.checkout[form].firstName.minCharacters;
                  } else {
                    fieldErrors[form].firstName = false;
                  }
                } else {
                  fieldErrors[form].firstName = true;
                  fieldErrorsMessage[form].firstName = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].firstName;
                }

                fieldErrors.fail = fieldErrors[form].firstName;
              } else {
                fieldErrors[form].firstName = false;
              }

              return _context5.abrupt("break", 44);

            case 36:
              if (state.validationsOn[form] && state.validations[form].surName) {
                if (value.length > 0) {
                  if (value.length <= 2) {
                    fieldErrors[form].surName = true;
                    fieldErrorsMessage[form].surName = errorMessages/* default.checkout */.Z.checkout[form].surName.minCharacters;
                  } else {
                    fieldErrors[form].surName = false;
                  }
                } else {
                  fieldErrors[form].surName = true;
                  fieldErrorsMessage[form].surName = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].surName;
                }

                fieldErrors.fail = fieldErrors[form].surName;
              } else {
                fieldErrors[form].surName = false;
              }

              return _context5.abrupt("break", 44);

            case 38:
              if (state.validationsOn[form] && state.validations[form].cellNumber) {
                if (value.length > 0) {
                  if (!numRegEx.test(value)) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkout */.Z.checkout[form].cellNumber.onlyNumber;
                  } else if (!cellPhoneRegEx.test(value)) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkout */.Z.checkout[form].cellNumber.startWith;
                  } else if ((0,helperServices/* africaCountryCode */.xJ)(value) && value.length < 11) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].cellNumber;
                  } else if (value.length < 10) {
                    fieldErrors[form].cellNumber = true;
                    fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].cellNumber;
                  } else {
                    fieldErrors[form].cellNumber = false;
                  }
                } else {
                  fieldErrors[form].cellNumber = true;
                  fieldErrorsMessage[form].cellNumber = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].cellNumber;
                }

                fieldErrors.fail = fieldErrors[form].cellNumber;
              } else {
                fieldErrors[form].cellNumber = false;
              }

              return _context5.abrupt("break", 44);

            case 40:
              if (state.validationsOn[form] && state.validations[form].email) {
                if (value.length > 0) {
                  fieldErrors[form].email = emailRegEx.test(value) ? false : true;

                  if (fieldErrors[form].email) {
                    fieldErrorsMessage.email = errorMessages/* default.checkout */.Z.checkout[form].email.onlyValid;
                  }
                } else {
                  fieldErrors[form].email = true;
                  fieldErrorsMessage[form].email = errorMessages/* default.checkout.errors.addressForm */.Z.checkout.errors.addressForm[form].email;
                }

                fieldErrors.fail = fieldErrors[form].email;
              } else {
                fieldErrors[form].email = false;
              }

              return _context5.abrupt("break", 44);

            case 42:
              if (state.validationsOn[form] && state.validations[form].instructions) {
                fieldErrors[form].instructions = value.length == 0 ? true : false;
                fieldErrors.fail = fieldErrors[form].instructions;
              } else {
                fieldErrors[form].instructions = false;
              }

              return _context5.abrupt("break", 44);

            case 44:
              setState(_objectSpread(_objectSpread({}, state), {}, {
                fieldErrors: fieldErrors,
                fieldErrorsMessage: fieldErrorsMessage
              }));

            case 45:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function fieldValidationCheck(_x13, _x14, _x15, _x16) {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   * Set the selection analytics(link)
   *
   * @call when dropdown value change
   */


  var selectionAnalytics = function selectionAnalytics(selectionType, value) {
    var linkType = getAnalyticsLinkType();
    analyticsUtag/* link */.p4(_objectSpread(_objectSpread({
      page_name: "".concat(pageName)
    }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
      visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
      page_tool_event: "use",
      page_tool_name: "".concat(pageName, ": ").concat(variant, " ").concat(linkType, ": ").concat(selectionType),
      filter_query: value
    }));
  };

  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      var _iterator = _createForOfIteratorHelper(entries),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = (0,slicedToArray/* default */.Z)(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          if (values[key] == "" && value || errors[key]) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    } else {
      return false;
    }
  }

  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (var _i = 0, _errValues = errValues; _i < _errValues.length; _i++) {
      var err = _errValues[_i];

      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }

    setSubmitDisabled(false);
  }

  function checkEntireFormError() {
    var entries = Object.entries(state.validationsOn);

    for (var _i2 = 0, _entries = entries; _i2 < _entries.length; _i2++) {
      var _entries$_i = (0,slicedToArray/* default */.Z)(_entries[_i2], 2),
          key = _entries$_i[0],
          value = _entries$_i[1];

      if (value) {
        return checkFormError(key);
      }

      return false;
    }
  }

  var addressSearchResultMap = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
      var localityType;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              localityType = finalAddress.address_components;

              if (!(localityType && localityType.length > 0)) {
                _context6.next = 9;
                break;
              }

              _context6.next = 4;
              return mapAddressSearchData(localityType);

            case 4:
              _context6.next = 6;
              return checkFormError(formType);

            case 6:
              errorStatus[formType] = _context6.sent;
              setState(_objectSpread(_objectSpread({}, state), {}, {
                errorStatus: errorStatus
              }));

              if (errorStatus[formType]) {
                setSubmitDisabled(true);
              } else {
                checkErrorStatus();
              }

            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function addressSearchResultMap() {
      return _ref7.apply(this, arguments);
    };
  }();

  var mapAddressSearchData = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(localityType) {
      var i;
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              readOnlyValues[formType].postalCode = false;
              fieldValues[formType].unitNo = "";
              fieldValues[formType].complexName = "";
              fieldValues[formType].streetNo = "";
              fieldValues[formType].streetName = "";
              fieldValues[formType].suburb = "";
              fieldValues[formType].province = "";
              fieldValues[formType].town = "";
              fieldValues[formType].postalCode = "";
              fieldErrors[formType].unitNo = false;
              fieldErrors[formType].complexName = false;
              fieldErrors[formType].streetNo = false;
              fieldErrors[formType].streetName = false;
              fieldErrors[formType].suburb = false;
              fieldErrors[formType].province = false;
              fieldErrors[formType].town = false;
              fieldErrors[formType].postalCode = false;

              for (i = 0; i < localityType.length; i++) {
                if (localityType[i].administrative_type == "unit") {
                  if (localityType[i].long_name) {
                    fieldValues[formType].unitNo = localityType[i].long_name;
                  }
                }

                if (localityType[i].administrative_type == "building") {
                  fieldValues[formType].complexName = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == "street_number") {
                  fieldValues[formType].streetNo = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == "route") {
                  fieldValues[formType].streetName = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == "suburb") {
                  fieldValues[formType].suburb = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == "province") {
                  fieldValues[formType].province = getProvinceValue(localityType[i].long_name);
                }

                if (localityType[i].administrative_type == "town" || localityType[i].administrative_type == "city") {
                  fieldValues[formType].town = localityType[i].long_name;
                }

                if (localityType[i].administrative_type == "post_street") {
                  if (localityType[i].long_name.length > 0) {
                    readOnlyValues[formType].postalCode = true;
                  }

                  fieldValues[formType].postalCode = localityType[i].long_name;
                }
              }

              setState(_objectSpread(_objectSpread({}, state), {}, {
                readOnlyValues: readOnlyValues,
                fieldValues: fieldValues,
                fieldErrors: fieldErrors
              }));

            case 19:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function mapAddressSearchData(_x17) {
      return _ref8.apply(this, arguments);
    };
  }();

  var mapContactFormData = function mapContactFormData() {
    var contactData = {
      firstName: "",
      surName: "",
      cellNumber: ""
    };

    if (formType == "delivery" || formType == "contactDetails") {
      contactData.firstName = state.fieldValues["contactDetails"].firstName !== "" ? state.fieldValues["contactDetails"].firstName : "";
      contactData.surName = state.fieldValues["contactDetails"].surName !== "" ? state.fieldValues["contactDetails"].surName : "";
      contactData.cellNumber = state.fieldValues["contactDetails"].cellNumber !== "" ? state.fieldValues["contactDetails"].cellNumber : "";
    } else {
      contactData.firstName = state.fieldValues["details"].firstName !== "" ? state.fieldValues["details"].firstName : "";
      contactData.surName = state.fieldValues["details"].surName !== "" ? state.fieldValues["details"].surName : "";
      contactData.cellNumber = state.fieldValues["details"].cellNumber !== "" ? state.fieldValues["details"].cellNumber : "";
    }

    return contactData;
  };

  var mapFieldData = function mapFieldData() {
    var formData = mapFormData();
    var contactFormData = mapContactFormData();
    var newValues = formType == "delivery" || formType == "billing" ? state.fieldValues[formType] : formData;
    var regionValue = getRegionValue(newValues.province);
    var newStreetName = null;

    if (formType == "delivery" || formType == "billing") {
      newStreetName = newValues.streetName !== "" && state.validations[formType].streetName ? seperateStreetString(newValues.streetName) : newValues.addressLine1 !== "" && newValues.addressLine2 !== "" && state.validations[formType].addressLine1 && state.validations[formType].addressLine2 ? createStreetFromAddressLines(newValues.addressLine1, newValues.addressLine2) : null;
    } else {
      newStreetName = newValues.streetName !== "" ? seperateStreetString(newValues.streetName) : newValues.addressLine1 !== "" && newValues.addressLine2 !== "" ? createStreetFromAddressLines(newValues.addressLine1, newValues.addressLine2) : null;
    }

    return {
      id: values.id ? values.id : null,
      region_id: regionValue && regionValue.id ? regionValue.id : null,
      region_code: regionValue && regionValue.code ? regionValue.code : null,
      region: regionValue && regionValue.name ? regionValue.name : null,
      country_code: countryCode ? countryCode : null,
      instructions: newValues.instructions !== "" ? newValues.instructions : null,
      street: newStreetName,
      postcode: newValues.postalCode !== "" ? newValues.postalCode : null,
      city: newValues.town !== "" ? newValues.town : null,
      address_type_name: newValues.addressType !== "" ? newValues.addressType : null,
      address_name: newValues.addressName !== "" ? newValues.addressName : null,
      company: newValues.companyName !== "" ? newValues.companyName : null,
      unit_number: newValues.unitNo !== "" ? newValues.unitNo : null,
      complex_name: newValues.complexName !== "" ? newValues.complexName : null,
      street_number: newValues.streetNo !== "" ? newValues.streetNo : null,
      suburb: newValues.suburb !== "" ? newValues.suburb : null,
      firstname: contactFormData.firstName,
      lastname: contactFormData.surName,
      telephone: contactFormData.cellNumber,
      email: state.fieldValues["details"].email !== "" ? state.fieldValues["details"].email : null,
      save_in_address_book: formData.futureCheck,
      default_shipping: false,
      default_billing: false,
      is_shipping_address: values.is_shipping_address ? values.is_shipping_address : 0,
      is_billing_address: values.is_billing_address ? values.is_billing_address : 0
    };
  };

  var refreshState = function refreshState() {
    validationsOn.delivery = false;
    validationsOn.billing = false;
    validationsOn.details = false;
    validationsOn.contactDetails = false;
    validationsOn.instructions = false;
    errorStatus.delivery = false;
    errorStatus.billing = false;
    errorStatus.details = false;
    errorStatus.contactDetails = false;
    errorStatus.instructions = false;
    validations.delivery.addressName = true;
    validations.delivery.addressType = true;
    validations.delivery.companyName = false;
    validations.delivery.addressLine1 = false;
    validations.delivery.addressLine2 = false;
    validations.delivery.unitNo = false;
    validations.delivery.complexName = false;
    validations.delivery.streetNo = false;
    validations.delivery.streetName = true;
    validations.delivery.suburb = true;
    validations.delivery.postalCode = true;
    validations.delivery.town = true;
    validations.delivery.province = true;
    validations.delivery.instructions = false;
    validations.billing.addressName = true;
    validations.billing.addressType = true;
    validations.billing.companyName = false;
    validations.billing.addressLine1 = false;
    validations.billing.addressLine2 = false;
    validations.billing.unitNo = false;
    validations.billing.complexName = false;
    validations.billing.streetNo = false;
    validations.billing.streetName = true;
    validations.billing.suburb = true;
    validations.billing.postalCode = true;
    validations.billing.town = true;
    validations.billing.province = true;
    validations.billing.instructions = false;
    validations.details.firstName = true;
    validations.details.surName = true;
    validations.details.cellNumber = true;
    validations.details.email = true;
    validations.contactDetails.firstName = true;
    validations.contactDetails.surName = true;
    validations.contactDetails.cellNumber = true;
    validations.instructions.instructions = true;
    fieldErrors.delivery.addressName = false;
    fieldErrors.delivery.addressType = false;
    fieldErrors.delivery.companyName = false;
    fieldErrors.delivery.addressLine1 = false;
    fieldErrors.delivery.addressLine2 = false;
    fieldErrors.delivery.unitNo = false;
    fieldErrors.delivery.complexName = false;
    fieldErrors.delivery.streetNo = false;
    fieldErrors.delivery.streetName = false;
    fieldErrors.delivery.suburb = false;
    fieldErrors.delivery.postalCode = false;
    fieldErrors.delivery.town = false;
    fieldErrors.delivery.province = false;
    fieldErrors.delivery.instructions = false;
    fieldErrors.billing.addressName = false;
    fieldErrors.billing.addressType = false;
    fieldErrors.billing.companyName = false;
    fieldErrors.billing.addressLine1 = false;
    fieldErrors.billing.addressLine2 = false;
    fieldErrors.billing.unitNo = false;
    fieldErrors.billing.complexName = false;
    fieldErrors.billing.streetNo = false;
    fieldErrors.billing.streetName = false;
    fieldErrors.billing.suburb = false;
    fieldErrors.billing.postalCode = false;
    fieldErrors.billing.town = false;
    fieldErrors.billing.province = false;
    fieldErrors.billing.instructions = false;
    fieldErrors.details.firstName = false;
    fieldErrors.details.surName = false;
    fieldErrors.details.cellNumber = false;
    fieldErrors.details.email = false;
    fieldErrors.contactDetails.firstName = false;
    fieldErrors.contactDetails.surName = false;
    fieldErrors.contactDetails.cellNumber = false;
    fieldErrors.instructions.instructions = false;
    fieldErrors.fail = false;
    fieldValues.delivery.addressName = "";
    fieldValues.delivery.addressType = RESIDENTIAL_ADDRESS_TYPE;
    fieldValues.delivery.companyName = "";
    fieldValues.delivery.addressLine1 = "";
    fieldValues.delivery.addressLine2 = "";
    fieldValues.delivery.unitNo = "";
    fieldValues.delivery.complexName = "";
    fieldValues.delivery.streetNo = "";
    fieldValues.delivery.streetName = "";
    fieldValues.delivery.suburb = "";
    fieldValues.delivery.postalCode = "";
    fieldValues.delivery.town = "";
    fieldValues.delivery.province = stateTypesOptions && stateTypesOptions.length > 0 ? stateTypesOptions[0].id : "";
    fieldValues.delivery.instructions = "";
    fieldValues.billing.addressName = "";
    fieldValues.billing.addressType = RESIDENTIAL_ADDRESS_TYPE;
    fieldValues.billing.companyName = "";
    fieldValues.billing.addressLine1 = "";
    fieldValues.billing.addressLine2 = "";
    fieldValues.billing.unitNo = "";
    fieldValues.billing.complexName = "";
    fieldValues.billing.streetNo = "";
    fieldValues.billing.streetName = "";
    fieldValues.billing.suburb = "";
    fieldValues.billing.postalCode = "";
    fieldValues.billing.town = "";
    fieldValues.billing.province = stateTypesOptions && stateTypesOptions.length > 0 ? stateTypesOptions[0].id : "";
    fieldValues.billing.instructions = "";
    fieldValues.details.firstName = values.firstName ? values.firstName : "";
    fieldValues.details.surName = values.surName ? values.surName : "";
    fieldValues.details.cellNumber = values.cellNumber ? values.cellNumber : "";
    fieldValues.details.email = "";
    fieldValues.contactDetails.firstName = "";
    fieldValues.contactDetails.surName = "";
    fieldValues.contactDetails.cellNumber = "";
    fieldValues.instructions.instructions = "";
    readOnlyValues.delivery.addressName = false;
    readOnlyValues.delivery.addressType = false;
    readOnlyValues.delivery.companyName = false;
    readOnlyValues.delivery.addressLine1 = false;
    readOnlyValues.delivery.addressLine2 = false;
    readOnlyValues.delivery.unitNo = false;
    readOnlyValues.delivery.complexName = false;
    readOnlyValues.delivery.streetNo = false;
    readOnlyValues.delivery.streetName = false;
    readOnlyValues.delivery.suburb = false;
    readOnlyValues.delivery.postalCode = false;
    readOnlyValues.delivery.town = false;
    readOnlyValues.delivery.province = false;
    readOnlyValues.delivery.instructions = false;
    readOnlyValues.billing.addressName = false;
    readOnlyValues.billing.addressType = false;
    readOnlyValues.billing.companyName = false;
    readOnlyValues.billing.addressLine1 = false;
    readOnlyValues.billing.addressLine2 = false;
    readOnlyValues.billing.unitNo = false;
    readOnlyValues.billing.complexName = false;
    readOnlyValues.billing.streetNo = false;
    readOnlyValues.billing.streetName = false;
    readOnlyValues.billing.suburb = false;
    readOnlyValues.billing.postalCode = false;
    readOnlyValues.billing.town = false;
    readOnlyValues.billing.province = false;
    readOnlyValues.billing.instructions = false;
    readOnlyValues.details.firstName = false;
    readOnlyValues.details.surName = false;
    readOnlyValues.details.cellNumber = false;
    readOnlyValues.details.email = false;
    readOnlyValues.contactDetails.firstName = false;
    readOnlyValues.contactDetails.surName = false;
    readOnlyValues.contactDetails.cellNumber = false;
    readOnlyValues.instructions.instructions = false;
    fieldErrorsMessage.delivery.addressName = "Please enter a name for this address";
    fieldErrorsMessage.delivery.addressType = "Please select your address type";
    fieldErrorsMessage.delivery.companyName = "Please enter your company name";
    fieldErrorsMessage.delivery.addressLine1 = "Please enter your postal address (Line 1)";
    fieldErrorsMessage.delivery.addressLine2 = "Please enter your postal address (Line 2)";
    fieldErrorsMessage.delivery.unitNo = "Please enter a unit no.";
    fieldErrorsMessage.delivery.complexName = "Please enter your complex name";
    fieldErrorsMessage.delivery.streetNo = "Please enter your street no.";
    fieldErrorsMessage.delivery.streetName = "Please enter your street name";
    fieldErrorsMessage.delivery.suburb = "Please enter and select your suburb";
    fieldErrorsMessage.delivery.postalCode = "Please enter your postal code";
    fieldErrorsMessage.delivery.town = "Please enter your town/city name";
    fieldErrorsMessage.delivery.province = "Please select your province";
    fieldErrorsMessage.delivery.instructions = "Please enter special instructions";
    fieldErrorsMessage.billing.addressName = "Please enter a name for this address";
    fieldErrorsMessage.billing.addressType = "Please select your address type";
    fieldErrorsMessage.billing.companyName = "Please enter your company name";
    fieldErrorsMessage.billing.addressLine1 = "Please enter your postal address (Line 1)";
    fieldErrorsMessage.billing.addressLine2 = "Please enter your postal address (Line 2)";
    fieldErrorsMessage.billing.unitNo = "Please enter a unit no.";
    fieldErrorsMessage.billing.complexName = "Please enter your complex name";
    fieldErrorsMessage.billing.streetNo = "Please enter your street no.";
    fieldErrorsMessage.billing.streetName = "Please enter your street name";
    fieldErrorsMessage.billing.suburb = "Please enter and select your suburb";
    fieldErrorsMessage.billing.postalCode = "Please enter your postal code";
    fieldErrorsMessage.billing.town = "Please enter your town/city name";
    fieldErrorsMessage.billing.province = "Please select your province";
    fieldErrorsMessage.billing.instructions = "Please enter special instructions";
    fieldErrorsMessage.details.firstName = "Please enter your first name";
    fieldErrorsMessage.details.surName = "Please enter your surname";
    fieldErrorsMessage.details.cellNumber = "Please enter your cellphone number";
    fieldErrorsMessage.details.email = "Please enter your email address";
    fieldErrorsMessage.contactDetails.firstName = "Please enter a first name";
    fieldErrorsMessage.contactDetails.surName = "Please enter your surname";
    fieldErrorsMessage.contactDetails.cellNumber = "Please enter a cellphone number";
    fieldErrorsMessage.instructions.instructions = "Please enter special instructions";
    setValidated(false);
    setSubmitDisabled(true);
    setShowConfirmModal(false);
    setConfirmModalContent("");
    setDeleteId(null);
    setState(_objectSpread(_objectSpread({}, state), {}, {
      validationsOn: validationsOn,
      errorStatus: errorStatus,
      validations: validations,
      fieldErrors: fieldErrors,
      fieldValues: fieldValues,
      fieldErrorsMessage: fieldErrorsMessage
    }));
  };

  function getAnalyticsLinkType() {
    var linkType = formType + " address";

    if (formType == "details" || formType == "contactDetails") {
      linkType = applicationType == "normal" ? "contact person" : "contact details";
    } else if (formType == "instructions") {
      linkType = "special instructions";
    }

    return linkType;
  }

  var addEditAddress = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8() {
      var inputAddressObj, linkType, results, _results$errors, _results$errors$, _results, _results2, _results2$errors, _results2$errors$, _results3, _results3$errors, _results3$errors$;

      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              inputAddressObj = mapFieldData();
              linkType = getAnalyticsLinkType();

              if (!(variant == "add")) {
                _context8.next = 18;
                break;
              }

              if (applicationType == "normal") {
                if (formType == "delivery") {
                  inputAddressObj.is_shipping_address = 1;
                } else if (formType == "billing") {
                  inputAddressObj.is_billing_address = 1;
                }
              } else {
                inputAddressObj.is_shipping_address = 1;
                inputAddressObj.is_billing_address = 1;
                inputAddressObj.same_as_shipping = true;
              }

              _context8.prev = 4;
              (0,helperServices/* showSpinner */.yh)();
              _context8.next = 8;
              return (0,checkoutService/* createCustomerAddressService */.qs)(inputAddressObj);

            case 8:
              results = _context8.sent;

              if (!results.fail) {
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({
                  page_name: "".concat(pageName)
                }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                  visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                  page_form_event: "success",
                  page_form_name: "".concat(pageName, ": ").concat(variant, " ").concat(linkType)
                }));
              } else {
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({
                  page_name: "".concat(pageName)
                }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                  visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                  page_form_event: "errors",
                  page_form_name: "".concat(pageName, ": ").concat(variant, " ").concat(linkType),
                  page_errors: results === null || results === void 0 ? void 0 : (_results$errors = results.errors) === null || _results$errors === void 0 ? void 0 : (_results$errors$ = _results$errors[0]) === null || _results$errors$ === void 0 ? void 0 : _results$errors$.message
                }));
              }

              modalClose(!results.fail, results);
              _context8.next = 16;
              break;

            case 13:
              _context8.prev = 13;
              _context8.t0 = _context8["catch"](4);
              modalClose();

            case 16:
              _context8.next = 41;
              break;

            case 18:
              _context8.prev = 18;
              (0,helperServices/* showSpinner */.yh)();
              _results = "";
              inputAddressObj.id = values.id ? values.id : values.customer_address_id;

              if (!inputAddressObj.id) {
                _context8.next = 29;
                break;
              }

              _context8.next = 25;
              return (0,checkoutService/* updateCustomerAddressService */.yH)(inputAddressObj);

            case 25:
              _results = _context8.sent;

              if (!_results.fail) {
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({
                  page_name: "".concat(pageName)
                }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                  visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                  page_form_event: "success",
                  page_form_name: "".concat(pageName, ": ").concat(variant, " ").concat(linkType)
                }));
              } else {
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({
                  page_name: "".concat(pageName)
                }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                  visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                  page_form_event: "errors",
                  page_form_name: "".concat(pageName, ": ").concat(variant, " ").concat(linkType),
                  page_errors: (_results2 = _results) === null || _results2 === void 0 ? void 0 : (_results2$errors = _results2.errors) === null || _results2$errors === void 0 ? void 0 : (_results2$errors$ = _results2$errors[0]) === null || _results2$errors$ === void 0 ? void 0 : _results2$errors$.message
                }));
              }

              _context8.next = 35;
              break;

            case 29:
              inputAddressObj.cart_id = cartId !== "" ? cartId : null;
              inputAddressObj.region = inputAddressObj.region_code;
              _context8.next = 33;
              return (0,checkoutService/* setNewShippingAddressService */.hQ)(inputAddressObj);

            case 33:
              _results = _context8.sent;

              if (!_results.fail) {
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({
                  page_name: "".concat(pageName)
                }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                  visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                  page_form_event: "success",
                  page_form_name: "".concat(pageName, ": ").concat(variant, " ").concat(linkType)
                }));
              } else {
                analyticsUtag/* link */.p4(_objectSpread(_objectSpread({
                  page_name: "".concat(pageName)
                }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash"])), {}, {
                  visitor_subscription_type: applicationType == "normal" ? analyticsData.visitor_subscription_type : "postpaid",
                  page_form_event: "errors",
                  page_form_name: "".concat(pageName, ": ").concat(variant, " ").concat(linkType),
                  page_errors: (_results3 = _results) === null || _results3 === void 0 ? void 0 : (_results3$errors = _results3.errors) === null || _results3$errors === void 0 ? void 0 : (_results3$errors$ = _results3$errors[0]) === null || _results3$errors$ === void 0 ? void 0 : _results3$errors$.message
                }));
              }

            case 35:
              modalClose(!_results.fail, _results);
              _context8.next = 41;
              break;

            case 38:
              _context8.prev = 38;
              _context8.t1 = _context8["catch"](18);
              modalClose();

            case 41:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[4, 13], [18, 38]]);
    }));

    return function addEditAddress() {
      return _ref9.apply(this, arguments);
    };
  }();

  var displyConfirmModal = function displyConfirmModal() {
    var newData = {
      id: values.id,
      name: values && values.address_name ? values.address_name : null,
      street: values && values.street_number && values.street_number != "" && values.street ? values.street_number + ", " + createStreetString(values.street) : values.street_number && values.street_number != "" ? values.street_number : values.street ? createStreetString(values.street) : null,
      suburb: values && values.suburb ? values.suburb : null,
      postcode: values && values.postcode ? values.postcode : null
    };
    var nameHTML = '<div class="' + (CheckoutFormsModal_module_default()).value + '"><span class="' + (CheckoutFormsModal_module_default()).value__first + '">' + newData.name + "</span>";
    var streetHTML = "";

    if (newData.street && newData.suburb && newData.postcode) {
      streetHTML = '<span class="' + (CheckoutFormsModal_module_default()).value__second + '">' + newData.street + ", " + newData.suburb + ", " + newData.postcode + "</span>";
    } else if (newData.suburb && newData.postcode) {
      streetHTML = '<span class="' + (CheckoutFormsModal_module_default()).value__second + '">' + newData.suburb + ", " + newData.postcode + "</span>";
    }

    var closeHTML = "</div>";
    var contentHTML = streetHTML !== "" ? nameHTML + streetHTML + closeHTML : nameHTML + closeHTML;
    setConfirmModalContent(contentHTML);
    setDeleteId(newData.id);
    setShowConfirmModal(true);
  };

  var cancelConfirmModel = function cancelConfirmModel() {
    setShowConfirmModal(false);
  };

  var approveConfirmModel = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9() {
      var results;
      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              setShowConfirmModal(false);
              _context9.prev = 1;
              (0,helperServices/* showSpinner */.yh)();
              _context9.next = 5;
              return (0,checkoutService/* deleteCustomerAddressService */.mV)(deleteId);

            case 5:
              results = _context9.sent;
              modalClose(!results.fail, results);
              _context9.next = 12;
              break;

            case 9:
              _context9.prev = 9;
              _context9.t0 = _context9["catch"](1);
              modalClose();

            case 12:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[1, 9]]);
    }));

    return function approveConfirmModel() {
      return _ref10.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal, {
      dialogClassName: "".concat((CheckoutFormsModal_module_default())[formType], " ").concat((CheckoutFormsModal_module_default())["checkout-forms-modal"]),
      show: show,
      onHide: modalClose,
      animation: false,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWithIcon/* default */.Z, {
        className: (CheckoutFormsModal_module_default())["back-button"],
        labelText: "Back",
        img_url_inactive: "".concat(imagePrefix, "/assets/images/caret-back.svg"),
        img_url_active: "".concat(imagePrefix, "/assets/images/caret-back.svg"),
        clickHandler: modalClose
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal.Header, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal.Title, {
          className: (CheckoutFormsModal_module_default())["modal-title"],
          id: "change-contact-details-title",
          children: variant == "add" ? addVariantObject[formType].modalTitle : variant == "edit" ? editVariantObject[formType].modalTitle : changeVariantObject[formType].modalTitle
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          className: (CheckoutFormsModal_module_default())["close-button"],
          img_path: "".concat(imagePrefix, "/assets/images/modal-close.svg"),
          onClick: modalClose
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Form, {
        noValidate: true,
        validated: validated,
        onSubmit: handleSubmit,
        className: (CheckoutFormsModal_module_default()).form,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal.Body, {
          className: (CheckoutFormsModal_module_default())["modal-body"],
          children: [(formType == "delivery" || formType == "billing") && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
              title: dataObject[formType].title,
              desc: dataObject[formType].desc
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "".concat("d-none " + (CheckoutFormsModal_module_default())["search-wrapper"]),
              children: state.fieldValues[formType].addressType !== POSTAL_ADDRESS_TYPE && /*#__PURE__*/(0,jsx_runtime.jsx)(ContentSearchBox/* default */.Z, {
                className: (CheckoutFormsModal_module_default())["search-wrapper__input"],
                placeholderText: "Search for your address",
                icon: "blue",
                variant: "address-search",
                setFinalAddress: setFinalAddress
              })
            }), step !== "creditCheck" && /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryAddress/* default */.Z, {
              formName: formType,
              variant: "popup",
              status: variant,
              validations: state.validations[formType],
              fieldValues: state.fieldValues[formType],
              fieldErrors: state.fieldErrors[formType],
              fieldErrorsMessage: state.fieldErrorsMessage[formType],
              readOnlyValues: state.readOnlyValues[formType],
              stateTypesOptions: stateTypesOptions,
              onChangeHandler: handleChange,
              onBlurHandler: handleBlur,
              containerClassName: (CheckoutFormsModal_module_default()).section
            }), step == "creditCheck" && /*#__PURE__*/(0,jsx_runtime.jsx)(DeliveryDetailsForm/* default */.Z, {
              formName: formType,
              variant: "popup",
              validations: state.validations[formType],
              fieldValues: state.fieldValues[formType],
              fieldErrors: state.fieldErrors[formType],
              fieldErrorsMessage: state.fieldErrorsMessage[formType],
              readOnlyValues: state.readOnlyValues[formType],
              addressTypesOptions: addressTypesOptions,
              stateTypesOptions: stateTypesOptions,
              onChangeHandler: handleChange,
              onBlurHandler: handleBlur,
              containerClassName: (CheckoutFormsModal_module_default()).section
            }), formType == "delivery" && variant !== "change" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
                title: dataObject.contactDetails.title,
                desc: dataObject.contactDetails.desc
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(PersonDetails/* default */.Z, {
                formName: "contactDetails",
                variant: "popup",
                fieldValues: state.fieldValues["contactDetails"],
                fieldErrors: state.fieldErrors["contactDetails"],
                fieldErrorsMessage: state.fieldErrorsMessage["contactDetails"],
                readOnlyValues: state.readOnlyValues["contactDetails"],
                onChangeHandler: handleChange,
                onBlurHandler: handleBlur,
                className: (CheckoutFormsModal_module_default()).section
              })]
            })]
          }), formType == "details" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
              title: dataObject.details.title,
              desc: dataObject.details.desc
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PersonDetails/* default */.Z, {
              formName: "details",
              variant: "popup",
              fieldValues: state.fieldValues["details"],
              fieldErrors: state.fieldErrors["details"],
              fieldErrorsMessage: state.fieldErrorsMessage["details"],
              readOnlyValues: state.readOnlyValues["details"],
              onChangeHandler: handleChange,
              onBlurHandler: handleBlur,
              className: (CheckoutFormsModal_module_default()).section
            })]
          }), formType == "contactDetails" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
              title: dataObject.contactDetails.title,
              desc: dataObject.contactDetails.desc
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(PersonDetails/* default */.Z, {
              formName: "contactDetails",
              variant: "popup",
              fieldValues: state.fieldValues["contactDetails"],
              fieldErrors: state.fieldErrors["contactDetails"],
              fieldErrorsMessage: state.fieldErrorsMessage["contactDetails"],
              readOnlyValues: state.readOnlyValues["contactDetails"],
              onChangeHandler: handleChange,
              onBlurHandler: handleBlur,
              className: (CheckoutFormsModal_module_default()).section
            })]
          }), formType == "instructions" && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormHeading/* default */.Z, {
              title: dataObject.instructions.title,
              desc: dataObject.instructions.desc
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(specialInstruction_SpecialInstruction, {
              formName: "instructions",
              variant: "popup",
              fieldValues: state.fieldValues["instructions"],
              fieldErrors: state.fieldErrors["instructions"],
              fieldErrorsMessage: state.fieldErrorsMessage["instructions"],
              readOnlyValues: state.readOnlyValues["instructions"],
              onChangeHandler: handleChange,
              onBlurHandler: handleBlur,
              className: (CheckoutFormsModal_module_default()).section
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal.Footer, {
          children: [variant == "edit" && deleteOption && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (CheckoutFormsModal_module_default())["delete-button"],
            onClick: displyConfirmModal,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(imagePrefix, "/assets/images/icon-trash-red.svg"),
              width: 18,
              height: 18,
              className: (CheckoutFormsModal_module_default()).image
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              children: "Delete this address"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
            type: "submit",
            className: (CheckoutFormsModal_module_default()).button,
            variant: "solid grey",
            disabled: submitDisabled,
            id: "validationFormsb101",
            children: variant == "add" ? addVariantObject[formType].buttonLabel : variant == "edit" ? editVariantObject[formType].buttonLabel : changeVariantObject[formType].buttonLabel
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
            type: "reset",
            className: (CheckoutFormsModal_module_default()).button,
            handleClick: modalClose,
            variant: "outline black",
            id: "validationFormsb102",
            children: "Cancel"
          })]
        })]
      })]
    }), showConfirmModal ? /*#__PURE__*/(0,jsx_runtime.jsx)(ConfirmModal/* default */.Z, {
      show: showConfirmModal,
      subtext: "You\u2019re about to delete this address:",
      text: confirmModalContent,
      handleConfirm: approveConfirmModel,
      handleCancel: cancelConfirmModel,
      confirmLabel: "Yes, delete this address"
    }) : null]
  });
};

CheckoutFormsModal.defaultProps = {
  show: false,
  formType: "delivery",
  variant: "add",
  addressTypes: [],
  statesTypes: [],
  deleteOption: true,
  pageName: "checkout: ec",
  isGuestUser: false,
  applicationType: "normal"
};
/* harmony default export */ var checkoutFormsModal_CheckoutFormsModal = (CheckoutFormsModal);

/***/ }),

/***/ 12426:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"CheckoutForms_main-container__BLBo5","popup":"CheckoutForms_popup__ECFMj","plain":"CheckoutForms_plain__h6nOb","main-row":"CheckoutForms_main-row__jPABv","form-group":"CheckoutForms_form-group__vNDx2","invalid":"CheckoutForms_invalid__Qz56L","invalid-feedback":"CheckoutForms_invalid-feedback__apmXs","hint-text":"CheckoutForms_hint-text__WzTKO","form-control-area":"CheckoutForms_form-control-area__wMqlF","form-label":"CheckoutForms_form-label__N0_Jl","form-checkbox-label":"CheckoutForms_form-checkbox-label__n1THl","form-row":"CheckoutForms_form-row__AS_ji"};

/***/ }),

/***/ 76167:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top-wrapper":"FormHeading_top-wrapper__g63JM","top-wrapper__heading":"FormHeading_top-wrapper__heading__13vuh","top-wrapper__desc":"FormHeading_top-wrapper__desc__R1YVc"};

/***/ }),

/***/ 68471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contact-check":"PersonDetails_contact-check__ZNCmw","form-info":"PersonDetails_form-info__rQk88","icon":"PersonDetails_icon__eeVFV","desc":"PersonDetails_desc__0lvKE"};

/***/ }),

/***/ 698:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select-component":"SelectDropDown_select-component__5fvjR","selected-value":"SelectDropDown_selected-value__hW2nT","invalid":"SelectDropDown_invalid__JCJkJ","menu":"SelectDropDown_menu__0zUXw","menu-item":"SelectDropDown_menu-item__KWoKi","menu-item__name":"SelectDropDown_menu-item__name__xxLhm","green-icon":"SelectDropDown_green-icon__4VEDh","active":"SelectDropDown_active__QWg_d","modal__title":"SelectDropDown_modal__title__CASEE","modal__close":"SelectDropDown_modal__close__xt6o_","modal__label":"SelectDropDown_modal__label__ItE9A","modal__reset":"SelectDropDown_modal__reset__3uPOJ","modal__body":"SelectDropDown_modal__body__UYuId"};

/***/ }),

/***/ 57470:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main-container":"NewLineForms_main-container__VTmML","popup":"NewLineForms_popup__nCedt","plain":"NewLineForms_plain__f_4Yl","main-row":"NewLineForms_main-row__Utq_8","form-group":"NewLineForms_form-group__LeyvC","invalid":"NewLineForms_invalid__5J_4W","disable-input":"NewLineForms_disable-input__XoHOF","invalid-feedback":"NewLineForms_invalid-feedback__2Scn_","error":"NewLineForms_error__0MJf1","hint-text":"NewLineForms_hint-text__mDvvC","text-spacing":"NewLineForms_text-spacing__EYWQ3","hint-text-spacing":"NewLineForms_hint-text-spacing___IRkh","form-control-area":"NewLineForms_form-control-area__EGEMK","custom-control":"NewLineForms_custom-control__dMoAB","form-row":"NewLineForms_form-row__jhlB9","form-label":"NewLineForms_form-label__beeOQ","form-checkbox-label":"NewLineForms_form-checkbox-label__scydm","form-radio-main-label":"NewLineForms_form-radio-main-label__wqYUb","form-radio-label":"NewLineForms_form-radio-label__KTVOd","checkbox-label":"NewLineForms_checkbox-label__H0x2_"};

/***/ }),

/***/ 29269:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select-component":"DropDown_select-component__5pAps","selected-value":"DropDown_selected-value__WT0T2","invalid":"DropDown_invalid__NFQoy","menu":"DropDown_menu__jvhWS","menu-item":"DropDown_menu-item__08yy2","menu-item__name":"DropDown_menu-item__name__nwkJc","green-icon":"DropDown_green-icon__U_Jay","active":"DropDown_active__foZIE","modal__title":"DropDown_modal__title__Igeiv","modal__close":"DropDown_modal__close__TZW2W","modal__label":"DropDown_modal__label__iCr5L","modal__reset":"DropDown_modal__reset__5Sest","modal__body":"DropDown_modal__body__mTJ3B"};

/***/ }),

/***/ 57289:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page-description":"PageDescription_page-description__q6Cww"};

/***/ }),

/***/ 45431:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkout-forms-modal":"CheckoutFormsModal_checkout-forms-modal__LQpQR","instructions":"CheckoutFormsModal_instructions__3Pjdl","back-button":"CheckoutFormsModal_back-button__znVA4","modal-title":"CheckoutFormsModal_modal-title__PwMrl","close-button":"CheckoutFormsModal_close-button__VdAUf","form":"CheckoutFormsModal_form__YyOKi","button":"CheckoutFormsModal_button__4mzGi","delete-button":"CheckoutFormsModal_delete-button__vuQDN","search-wrapper":"CheckoutFormsModal_search-wrapper__PAvlT","search-wrapper__input":"CheckoutFormsModal_search-wrapper__input__1Dacg","section":"CheckoutFormsModal_section__JQex7","value":"CheckoutFormsModal_value__k2ADs","value__second":"CheckoutFormsModal_value__second__gYsuF"};

/***/ })

}]);